<template>
  <v-container fluid>
    <div>
      <h2 class=" mb-3">{{ $t('Order Summary') }}</h2>
      <template v-if="selectedBot.line_my_shop_is_active">
        <v-btn
          small
          :outline="orderBy !== 'zwiz'"
          dark
          color="primary"
          class="ml-0 mr-0"
          @click="selectOrderBy('zwiz')"
        >
          Zwiz Shop
        </v-btn>
        <v-btn
          v-if="selectedBot.line_my_shop_is_active"
          small
          :outline="orderBy !== 'lineMyShop'"
          color="primary"
          class="ml-1 mr-0"
          @click="selectOrderBy('lineMyShop')"
        >
          LINE SHOPPING
        </v-btn>
      </template>
      <template v-if="orderBy === 'zwiz'">
        <div class="mb-2">
          <v-layout wrap>
            <v-flex xs11 style="align-self: center;">
              <date-filter
                v-model="selectedDate"
                @changeDate="onSelectedDate"
                :default-filter="'today'"
                :showTime="true"
                :disabled="isActiveFilter"
                ref="dateFilter"
              ></date-filter>
            </v-flex>
            <v-flex xs1 class="text-xs-right">
              <v-btn
                fab
                outline
                color="primary"
                @click="onRefresh"
                v-tooltip.top="$t('Refresh')"
                small
              >
                <i class="fa fa-refresh"></i>
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="loading" class="text-xs-center" style="min-height: 400px">
          <v-layout justify-center align-center row style="height: 400px">
            <v-flex>
              <div class="spinner text-xs-center">
                <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
              </div>
            </v-flex>
          </v-layout>
        </div>
        <template v-else>
          <v-layout wrap>
            <v-flex sm9 xs12>
              <div
                class="nav nav-tabs"
                style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
              >
                <!-- <v-btn
                  v-for="(item, index) in statusItems"
                  :class="index < statusItems.length - 1 ? 'mr-3 ml-0' : 'mx-0'"
                  :outline="!filterStatus.includes(item.value)"
                  color="primary"
                  depressed
                  small
                  :key="`status-item-${index}`"
                  style="with: max-content"
                  @click="activeFilterStatus(item.value)"
                >
                  {{ item.text }}
                  {{ badge[item.value] > 0 ? '(' + badge[item.value] + ')' : '' }}
                  <v-btn
                    icon
                    small
                    :ripple="false"
                    @click.prevent.stop="inactiveFilterStatus(item.value)"
                    v-if="filterStatus.includes(item.value)"
                  >
                    <v-icon color="white" size="24px">cancel</v-icon>
                  </v-btn>
                </v-btn> -->
                <v-btn
                  small
                  depressed
                  class="ma-1"
                  style="margin-left: 0px !important;"
                  @click="changeStatus('all')"
                  :outline="filterStatus != 'all'"
                  :color="filterStatus != 'all' ? 'grey' : 'primary'"
                  >{{ $t('All') }} {{ badge.all > 0 ? '(' + badge.all + ')' : '' }}</v-btn
                >
                <v-btn
                  small
                  depressed
                  class="ma-1"
                  @click="changeStatus('pending')"
                  :outline="filterStatus != 'pending'"
                  :color="filterStatus != 'pending' ? 'grey' : 'primary'"
                  >{{ $t('pending') }}
                  {{ badge.pending > 0 ? '(' + badge.pending + ')' : '' }}</v-btn
                >
                <v-btn
                  small
                  depressed
                  class="ma-1"
                  @click="changeStatus('ordered')"
                  :outline="filterStatus != 'ordered'"
                  :color="filterStatus != 'ordered' ? 'grey' : 'primary'"
                  >{{ $t('ordered') }}
                  {{ badge.ordered > 0 ? '(' + badge.ordered + ')' : '' }}</v-btn
                >
                <v-btn
                  small
                  depressed
                  class="ma-1"
                  @click="changeStatus('paid')"
                  :outline="filterStatus != 'paid'"
                  :color="filterStatus != 'paid' ? 'grey' : 'primary'"
                  >{{ $t('paid') }} {{ badge.paid > 0 ? '(' + badge.paid + ')' : '' }}</v-btn
                >
                <v-btn
                  small
                  depressed
                  class="ma-1"
                  @click="changeStatus('shipped')"
                  :outline="filterStatus != 'shipped'"
                  :color="filterStatus != 'shipped' ? 'grey' : 'primary'"
                  >{{ $t('shipped') }}
                  {{ badge.shipped > 0 ? '(' + badge.shipped + ')' : '' }}</v-btn
                >
                <v-btn
                  small
                  depressed
                  class="ma-1"
                  @click="changeStatus('canceled')"
                  :outline="filterStatus != 'canceled'"
                  :color="filterStatus != 'canceled' ? 'grey' : 'primary'"
                >
                  {{ $t('cancel') }}
                  {{ badge.canceled > 0 ? '(' + badge.canceled + ')' : '' }}
                </v-btn>
              </div>
              <div
                v-if="isCentralLive"
                class="nav nav-tabs"
                style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
              >
                <v-btn
                  small
                  depressed
                  class="ma-1"
                  @click="changeCategory({ name: 'all' })"
                  :outline="filterCategoryStatus != 'all'"
                  :color="filterCategoryStatus != 'all' ? 'grey' : 'primary'"
                  >{{ $t('All') }}</v-btn
                >
                <v-btn
                  small
                  v-for="category in categories"
                  :key="category.id"
                  depressed
                  class="ma-1"
                  @click="changeCategory(category)"
                  :outline="filterCategoryStatus != category.name"
                  :color="filterCategoryStatus != category.name ? 'grey' : 'primary'"
                  >{{ category.name }}</v-btn
                >
              </div>
            </v-flex>
            <v-flex sm3 md3 class="px-1 text-xs-right">
              <v-btn dark depressed color="primary" @click="showAdvance = !showAdvance">
                <v-icon>search</v-icon>
                &nbsp;
                {{ $t('advanced search') }}&nbsp;
              </v-btn>
              <v-dialog v-model="showAdvance" max-width="750" persistent>
                <v-card style="max-height: 600">
                  <div class="text-xs-right">
                    <v-btn flat fab small @click="showAdvance = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </div>
                  <v-card-text>
                    <div class="caption">{{ $t('Channel') }}</div>
                    <div>
                      <v-combobox
                        v-model="social"
                        :items="socialItems"
                        item-text="text"
                        item-value="value"
                        item-disabled="disabled"
                        autocomplete
                        multiple
                        outline
                        single-line
                        chips
                      ></v-combobox>
                    </div>
                    <div class="caption">{{ $t('Search Order Number') }}</div>
                    <div>
                      <v-combobox
                        v-model="orderNumbers"
                        outline
                        :items="[]"
                        append-icon=""
                        autocomplete
                        multiple
                        single-line
                        ref="comboboxOrderNumbers"
                        chips
                      >
                        <template v-slot:append-outer>
                          <v-menu v-model="menuVisible" offset-y absolute class="custom-menu">
                          </v-menu>
                        </template>
                        <template v-slot:selection="{ item }">
                          <v-chip label small>
                            <span class="pr-2">
                              {{ item }}
                            </span>
                            <v-icon small @click="removeOrderNumber(item)">close</v-icon>
                          </v-chip>
                        </template>
                      </v-combobox>
                    </div>
                    <div class="caption">{{ $t('created_order_by') }}</div>
                    <v-radio-group
                      class="mt-0"
                      color="primary"
                      v-model="createBillType"
                      row
                      @change="handleChangeBillType"
                    >
                      <v-radio color="primary" :value="'all'">
                        <template slot="label">
                          <span>{{ $t('all_bill') }}</span>
                        </template>
                      </v-radio>
                      <v-radio color="primary" :value="'admin'">
                        <template slot="label">
                          <span>{{ $t('admin_bill') }}</span>
                        </template>
                      </v-radio>
                      <v-radio color="primary" :value="'customer'">
                        <template slot="label">
                          <span>{{ $t('customer_bill') }}</span>
                        </template>
                      </v-radio>
                      <v-radio color="primary" :value="'conversion'">
                        <template slot="label">
                          <span>{{ $t('chat_bill') }}</span>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <template v-if="createBillType === 'admin' || createBillType === 'all'">
                      <div class="caption">{{ $t('admin_name') }}</div>
                      <div class="form-control">
                        <input type="text" v-model="adminName" />
                      </div>
                    </template>
                    <template v-if="createBillType !== 'conversion'">
                      <div class="caption">{{ $t('Coupon Code') }}</div>
                      <div class="form-control">
                        <input type="text" v-model="coupon" />
                      </div>
                    </template>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="grey"
                      outline
                      @click="
                        () => {
                          clearAllSearch(), (isActiveFilter = false)
                        }
                      "
                      >{{ $t('Clear All') }}</v-btn
                    >
                    <v-btn color="primary" depressed @click="filterOrderSummary()">{{
                      $t('Search')
                    }}</v-btn>
                    <v-spacer />
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex>
            <!-- <v-flex xs12 class="mb-3">
              <v-btn
                v-for="(item, index) in createdByItems"
                :class="index > 0 && index < createdByItems.length - 1 ? 'mx-3' : 'mx-0'"
                :outline="!filterCreatedBy.includes(item.value)"
                color="primary"
                depressed
                small
                :key="`created-by-item-${index}`"
                style="with: max-content"
                @click="activeFilterCreatedBy(item.value)"
              >
                {{ item.text }}
                <v-btn
                  icon
                  small
                  :ripple="false"
                  @click.prevent.stop="inactiveFilterCreatedBy(item.value)"
                  v-if="filterCreatedBy.includes(item.value)"
                >
                  <v-icon color="white" size="24px">cancel</v-icon>
                </v-btn>
              </v-btn>
            </v-flex> -->
            <v-flex xs12 sm6 md3 class="form-control px-1">
              <input type="text" :placeholder="$t('Search')" v-model="search" />
            </v-flex>

            <v-flex sm6 md3 class="px-1">
              <multiselect
                v-if="shippingOptions.length"
                label="name"
                v-model="shippingFilter"
                :options="filteredShipping"
                :placeholder="$t('Shipping')"
                track-by="value"
                :multiple="true"
                @input="changeShippingOption"
              >
                <template slot="option" slot-scope="props">
                  <span class="option__title"
                    >{{ $t(props.option.name) }} ({{ props.option.count }})</span
                  >
                </template>
              </multiselect>
            </v-flex>

            <v-flex sm6 md3 class="px-1">
              <multiselect
                label="text"
                v-model="filterCreatedBy"
                :options="createdByItems"
                :placeholder="$t('created_by_type')"
                track-by="value"
                :multiple="true"
              >
              </multiselect>
            </v-flex>

            <v-flex sm6 md3 class="px-1">
              <multiselect
                v-if="filterPayment.length"
                label="name"
                v-model="paymentFilter"
                :options="filterPayment"
                :placeholder="$t('Payments')"
                track-by="value"
                :multiple="true"
                @input="changePaymentOption"
              >
                <template slot="option" slot-scope="props">
                  <span class="option__title"
                    >{{ $t(props.option.name) }} ({{ props.option.count }})</span
                  >
                </template>
              </multiselect>
            </v-flex>
            <v-flex xs12 sm12 style="width: 100%; overflow: auto;" class="text-xs-left">
              <v-divider class="mt-3 mb-1"></v-divider>
              <div class="text-xs-left">
                <v-layout>
                  <v-btn
                    outline
                    color="grey"
                    @click="exportOrderSummary"
                    class="mr-0"
                    style="border-right: 0; display: inline-block; border-radius: 20px 0px 0px 0px !important;"
                  >
                    <!-- @click="exportOrderSummary('separate')" -->
                    <i class="fas fa-file-export mr-1"></i>
                    {{ $t('export') }}
                  </v-btn>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="grey"
                        v-on="on"
                        style="display: inline-block; border-radius: 0; margin-left: -10px; border-radius: 0px 20px 20px 0px !important"
                        outline
                        icon
                      >
                        <v-icon>arrow_drop_down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile @click="exportOrderSummary('merge')">
                        <v-list-tile-title>{{ $t('Export merge products') }}</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="exportOrderSummary('separate')">
                        <v-list-tile-title>{{ $t('Export separate products') }}</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="exportOrderSummary('kerry')">
                        <v-list-tile-title>{{ $t('Export kerry format') }}</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click.stop="modal = true">
                        <v-list-tile-title>{{ $t('export_customize_products') }}</v-list-tile-title>
                        <customize-order-summary
                          v-if="modal"
                          v-model="modal"
                          :orderSum="filterOrders"
                        />
                      </v-list-tile>
                      <v-list-tile
                        v-if="
                          [
                            '148831989096546',
                            '1229692217050821',
                            '135565533158593',
                            '488563718210335',
                            '799590883441878'
                          ].includes(selectedBot.pageid)
                        "
                        @click="exportOrderSummary('sap')"
                      >
                        <v-list-tile-title>{{ $t('Export SAP format') }}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                  <span>
                    <v-dialog persistent v-model="isEditShop" width="800">
                      <template v-slot:activator="{ on }">
                        <v-btn color="grey" outline v-on="on">
                          <v-icon class="mr-1">edit</v-icon>
                          {{ $t('Edit Shop') }}
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-text>
                          <h3 class="title">{{ $t('Profile') }}</h3>
                          <!-- <v-layout wrap>
                          <v-flex sm6>
                            <h2 class="mb-2">{{ $t('Profile') }}</h2>
                          </v-flex>
                          <v-flex sm6 class="text-xs-right">
                            <v-btn fab small flat @click="isEditShop = false">
                              <v-icon>close</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout> -->

                          <shop-profile
                            :modalOpen="isEditShop"
                            :isEdit="true"
                            :showAddress="true"
                            @onSave="isEditShop = false"
                          ></shop-profile>
                          <!-- :isEdit="false"
                          :showAddress="false" -->
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-text>
                          <h2 class="mb-2">{{ $t('Shop address') }}</h2>
                          <shipping-address></shipping-address>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </span>
                  <template v-if="selectedBot.page_receipt_status">
                    <export-invoice :orders.sync="filterOrders"> </export-invoice>
                  </template>
                  <span>
                    <PrintAllCoversMonobo
                      v-if="
                        [
                          '148831989096546',
                          '1229692217050821',
                          '135565533158593',
                          '488563718210335',
                          '799590883441878'
                        ].includes(selectedBot.pageid)
                      "
                      :orders="filterOrders"
                      :circle="false"
                      @onPrinCover="onPrinCover(true, $event)"
                      class="d-inline-block"
                    ></PrintAllCoversMonobo>
                    <PrintAllCoversCentral
                      v-if="$store.state.centralPage.includes(selectedBot.pageid)"
                      :orders.sync="filterOrders"
                      :circle="false"
                      @onPrinCover="onPrinCover(false, $event)"
                      class="d-inline-block"
                    ></PrintAllCoversCentral>
                    <print-all-covers
                      v-else
                      :orders.sync="filterOrders"
                      :circle="false"
                      @onPrinCover="onPrinCover(false, $event)"
                      class="d-inline-block"
                    ></print-all-covers>
                  </span>
                  <template>
                    <manage-orderno
                      :filterStatus.sync="filterStatus"
                      :filterOrders.sync="filterOrders"
                      @onRefresh="onRefresh"
                    >
                    </manage-orderno>
                  </template>
                  <v-btn
                    v-if="selectedBot.zortout_is_active"
                    color="#e5c813"
                    :loading="loadingZortout"
                    depressed
                    dark
                    @click.stop="dialogZortoutOpen()"
                    style="display: inline-block; margin-right: -5px; border-radius: 20px 20px 20px 0px !important;"
                  >
                    <v-icon class="mr-1">local_shipping</v-icon>{{ $t('send_by_zortout') }}
                  </v-btn>

                  <template v-if="selectedBot.scg_express_is_active">
                    <shipping-scg v-model="summary" :cbAll.sync="cbAll" @onRefresh="onRefresh">
                    </shipping-scg>
                  </template>
                  <template v-if="selectedBot.ninja_van_is_active">
                    <shipping-ninja v-model="summary" :cbAll.sync="cbAll" @onRefresh="onRefresh" />
                  </template>
                  <shipping-jt v-model="summary" :cbAll.sync="cbAll" @onRefresh="onRefresh">
                  </shipping-jt>
                  <template
                    v-if="selectedBot.pagetype !== 'enterprise' && selectedBot.shippop_status"
                  >
                    <div style="display: flex;">
                      <v-btn
                        color="#0b9dd1"
                        :loading="loadingShippop"
                        depressed
                        dark
                        @click.stop="shipWithShippop"
                        style="display: inline-block; margin-right: -5px; border-radius: 20px 0px 0px 0px !important;"
                      >
                        <v-icon class="mr-1">local_shipping</v-icon>ส่งกับ Shippop
                      </v-btn>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="grey"
                            v-on="on"
                            class="ml-0"
                            style="display: inline-block; border-radius: 0 ;background-color: rgb(11, 157, 209) !important;
                          color: white !important;
                          border-color: darkgray;
                          border-radius: 0px 20px 20px 0px !important"
                            outline
                            icon
                          >
                            <v-icon>arrow_drop_down</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-tile :href="`/${currentLang}/template?tab=Shippop`">
                            <v-list-tile-title>{{ $t('ดูรายการที่เคยส่ง') }}</v-list-tile-title>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                    </div>
                  </template>
                  <template
                    v-if="
                      selectedBot.pagetype !== 'enterprise' &&
                        selectedBot.lalamove_info &&
                        selectedBot.lalamove_info.status
                    "
                  >
                    <div class="d-inline-block">
                      <v-btn
                        color="#F26722"
                        depressed
                        dark
                        :href="`/${currentLang}/template?tab=LalamoveOrderList`"
                      >
                        <v-icon class="mr-1">local_shipping</v-icon>ดูประวัติ Lalamove
                      </v-btn>
                    </div>
                  </template>
                  <template
                    v-if="
                      check_privilege('sokochan') &&
                        selectedBot.sokochan_info &&
                        selectedBot.sokochan_info.status
                    "
                  >
                    <div class="d-inline-block">
                      <v-btn
                        color="#f8a41a"
                        depressed
                        dark
                        @click.stop="shipWithSokochan"
                        style="display: inline-block; margin-right: -5px"
                      >
                        <v-icon class="mr-1">local_shipping</v-icon>ส่งกับ Sokochan
                      </v-btn>
                    </div>
                  </template>

                  <template
                    v-if="selectedBot.pagetype !== 'enterprise' && selectedBot.packhai_status"
                  >
                    <div class="d-inline-block">
                      <v-btn
                        color="red"
                        depressed
                        dark
                        @click.stop="shipWithPackhai"
                        style="display: inline-block; margin-right: -5px"
                      >
                        <v-icon class="mr-1">local_shipping</v-icon>ส่งกับ Packhai
                      </v-btn>
                    </div>
                  </template>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>

          <div>
            <v-layout wrap>
              <v-flex xs12 class="text-xs-center text-sm-right">
                <v-pagination
                  v-model="pageNumber"
                  :length="pageCount"
                  @input="onClickPageinate"
                  class="mb-2"
                ></v-pagination>
              </v-flex>
            </v-layout>
            <div style>
              <template v-if="filterSummary.length > 0">
                <v-layout>
                  <v-flex sm3>
                    <v-checkbox
                      id="cbAll"
                      :label="$t('Check all')"
                      style="display: inline-block; margin: 0"
                      v-model="checkboxAll"
                      @change="clickCbAll"
                      color="primary"
                    ></v-checkbox>
                  </v-flex>
                  <v-spacer />
                  <v-flex right-align style="padding-right: 1em"></v-flex>
                  <v-flex sm4>
                    <multiselect
                      label="label"
                      v-model="status"
                      :disabled="!cbAll.length"
                      :options="orderStatusOptions"
                      :allow-empty="true"
                      :searchable="false"
                      :placeholder="$t('Modify all status')"
                      selectLabel
                      selectedLabel
                      deselect-label
                      @select="onConfirmCancelOrder"
                    ></multiselect>
                  </v-flex>
                </v-layout>
                <template v-for="(order, index) in filterSummary">
                  <template v-if="selectedBot.pageid == '114660513608160'">
                    <forex-summary-item
                      :key="'forex_order_' + index"
                      :cbAll.sync="cbAll"
                      @assignCb="assignCb"
                      v-model="filterSummary[index]"
                      @updateOrder="updateOrder(order.id, $event)"
                      @onChangeStatus="onChangeStatus(order.id)"
                      :shippingOptions="shippingOptions"
                      :showProductDetail="showProductDetail"
                      @onShowProductDetail="onShowProductDetail"
                    ></forex-summary-item>
                  </template>
                  <template
                    v-else-if="
                      [
                        '148831989096546',
                        '1229692217050821',
                        '135565533158593',
                        '488563718210335',
                        '799590883441878'
                      ].includes(selectedBot.pageid)
                    "
                  >
                    <monobo-summary-item
                      :key="'monobo_order_' + order.id"
                      :cbAll.sync="cbAll"
                      @assignCb="assignCb"
                      v-model="filterSummary[index]"
                      @updateOrder="updateOrder(order.id, $event)"
                      @onChangeStatus="onChangeStatus(order.id)"
                      :shippingOptions="shippingOptions"
                      :showProductDetail="showProductDetail"
                      @onShowProductDetail="onShowProductDetail"
                    ></monobo-summary-item>
                  </template>
                  <template v-else>
                    <summary-item
                      :key="'order_' + order.id + '_' + order.virual_timestamp"
                      :cbAll.sync="cbAll"
                      @assignCb="assignCb"
                      v-model="filterSummary[index]"
                      @updateOrder="updateOrder(order.id, $event)"
                      @onChangeStatus="onChangeStatus(order.id)"
                      :shippingOptions="shippingOptions"
                      :showProductDetail="showProductDetail"
                      @onShowProductDetail="onShowProductDetail"
                    ></summary-item>
                  </template>
                </template>
                <div class="text-xs-right" style="padding-top: 10px">
                  <v-pagination
                    v-model="pageNumber"
                    :length="pageCount"
                    @input="onClickPageinate"
                    class="mb-2"
                  ></v-pagination>
                </div>
              </template>
              <template v-else>
                <div class="text-xs-center" style="margin: 35px 0">
                  <img
                    src="/static/img/assets/ecommerce/empty_shopping_cart.png"
                    alt
                    style="width: 230px"
                  />
                  <h2>{{ $t('No data') }}</h2>
                </div>
              </template>
            </div>
          </div>
        </template>
      </template>
      <template v-if="orderBy === 'lineMyShop'">
        <line-my-shop-summary></line-my-shop-summary>
      </template>
    </div>

    <shippop-shipping
      :key="shippoptimestamp"
      v-model="showFilterShippopPackage"
      :orders="filterShippopPackages"
      @isEditShop="isEditShop = true"
      @getOrderErrorShippop="getOrderErrorShippop"
    ></shippop-shipping>

    <packhai-shipping
      :key="'packhai_' + packhaitimestamp"
      v-model="showFilterPackhaiPackage"
      :orders="filterPackhaiPackages"
      @isEditShop="isEditShop = true"
      @updateStatus="packhaiUpdateStatus"
    ></packhai-shipping>

    <sokochan-shipping
      :key="'sokochan_' + sokochantimestamp"
      v-model="showFilterSokochanPackage"
      :orders="filterSokochanPackages"
      @isEditShop="isEditShop = true"
      @updateStatus="sokochanUpdateStatus"
    ></sokochan-shipping>
    <div class="mb-5 mt-5"></div>

    <v-dialog persistent v-model="dialogShippop" width="1500">
      <v-card>
        <v-card-text v-if="dialogShippop">
          <div class="text-xs-right">
            <v-btn fab small flat @click="dialogShippop = false">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <template v-for="(order, index) in filterSummaryShippop">
            <summary-item
              :key="'order_' + order.id + '_' + order.virual_timestamp"
              :cbAll.sync="cbAll"
              @assignCb="assignCb"
              v-model="filterSummaryShippop[index]"
              @updateOrder="updateOrder(order.id, $event)"
              @onChangeStatus="onChangeStatus(order.id)"
              :shippingOptions="shippingOptions"
              :showProductDetail="showProductDetail"
              @onShowProductDetail="onShowProductDetail"
            ></summary-item>
          </template>
          <div class="mt-3 text-xs-center">
            <v-btn
              outline
              color="primary"
              :loading="loadingShippop"
              depressed
              @click.stop="dialogShippop = false"
              style="display: inline-block;"
            >
              <v-icon class="mr-1"></v-icon>ย้อนกลับ
            </v-btn>
            <v-btn
              color="#0b9dd1"
              :loading="loadingShippop"
              depressed
              dark
              @click.stop="shipWithShippop"
              style="display: inline-block;"
            >
              <v-icon class="mr-1">local_shipping</v-icon>ส่งกับ Shippop
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="dialogZortout" width="500">
      <v-card>
        <v-card-text v-if="dialogZortout">
          <v-layout wrap>
            <v-flex xs10 style="align-self: center"
              ><h3>{{ $t('type_vat') }}</h3>
            </v-flex>
            <v-flex xs2 class="text-xs-right">
              <v-btn fab small flat @click="dialogZortout = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>

          <v-radio-group v-model="zortout_select_vat_type" row>
            <v-radio color="primary" :label="$t('no_vat')" :value="1"></v-radio>
            <v-radio color="primary" :label="$t('exclude_vat')" :value="2"></v-radio>
            <v-radio color="primary" :label="$t('include_vat')" :value="3"></v-radio>
          </v-radio-group>
          <div class="text-xs-center">
            <v-btn
              outline
              color="primary"
              :loading="loadingZortout"
              depressed
              @click.stop="dialogZortout = false"
              style="display: inline-block;"
            >
              <v-icon class="mr-1"></v-icon>{{ $t('cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              :loading="loadingZortout"
              depressed
              dark
              @click.stop="shipWithZortout"
              style="display: inline-block;"
            >
              <v-icon class="mr-1">local_shipping</v-icon>{{ $t('send_by_zortout') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import $ from 'jquery'
import { mapGetters } from 'vuex'
import datepicker from 'vuejs-datepicker'

import Editable from '@/components/elements/Editable'
import api from '@/api'
import dayjs from 'dayjs'
import numeral from 'numeral'
import XLSX from 'xlsx'
import SummaryItem from './SummaryItem'
import ForexSummaryItem from './ForexSummaryItem'
import MonoboSummaryItem from './MonoboSummaryItem'
import OrderSummaryMobile from './OrderSummaryMobile'
import ModalHelp from '@/components/elements/ModalHelp'
import Multiselect from 'vue-multiselect'
import PrintAllCovers from './PrintAllCovers.vue'
import PrintAllCoversMonobo from './PrintAllCoversMonobo.vue'
import PrintAllCoversCentral from './PrintAllCoversCentral.vue'
import ShopProfile from '@/components/view/setting/ecommerce/ShopProfile'
import SelectShippopCourier from './SelectShippopCourier'

import ShippopShipping from './ShippopShipping.vue'
import ShippingAddress from '@/components/view/setting/ecommerce/ShippingAddress'
import ShippingJt from '@/components/view/template/ecommerce/ShippingJt.vue'
import PrintChillBill from './PrintChillBill'
import DateFilter from '@/components/view/analytics/DateFilter'
import ExportInvoice from '@/components/view/template/ecommerce/ExportInvoice'
import PackhaiShipping from './PackhaiShipping'
import SokochanShipping from './SokochanShipping'
import { cloneDeep } from 'lodash'
import ManageOrderno from '@/components/view/template/ecommerce/ManageOrderno'
import LineMyShopSummary from './LineMyShopSummary'
import ShippingScg from '@/components/view/template/ecommerce/ShippingScg.vue'
import customizeOrderSummary from '../ecommerce/components/CustomOrderSummary.vue'
import ShippingNinja from '@/components/view/template/ecommerce/ShippingNinja.vue'
export default {
  data: function() {
    return {
      orderBy: 'zwiz',
      createBillType: 'all',
      zortoutOrder: {
        status: '',
        loading: false,
        interval: null,
        show: false
      },

      modal: false,
      dialogShippop: false,
      dialogZortout: false,
      zortout_select_vat_type: 1,
      loading: true,
      shippingFilter: [],
      shippingOptions: [],
      isEditShop: false,
      cbAll: [],
      checkboxAll: false,
      pageNumber: 1,
      size: 10,
      search: '',
      filterStatus: 'all',
      showStartTimeDialog: false,
      showEndTimeDialog: false,
      starttime: '00:00',
      endtime: '23:59',
      showProductDetail: '',
      selectedDate: {
        start: dayjs().format('YYYY-MM-DD 00:00'),
        end: dayjs().format('YYYY-MM-DD 23:59')
      },
      summary: [],
      summaryShippop: [],
      lang: {
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec'
        ],
        pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
        placeholder: {
          date: 'Select Date',
          dateRange: 'Select Date Range'
        }
      },
      currentFilter: 'today',
      badge: {
        all: 0,
        pending: 0,
        canceled: 0,
        ordered: 0,
        paid: 0,
        shipped: 0
      },
      categorybadgebadge: {
        all: 0,
        canceled: 0,
        ordered: 0,
        paid: 0,
        shipped: 0
      },
      categories: [],
      status: '',
      orderStatusOptions: [
        {
          label: this.$t('pending'),
          value: 'pending'
        },
        {
          label: this.$t('ordered'),
          value: 'ordered'
        },
        {
          label: this.$t('paid'),
          value: 'paid'
        },
        {
          label: this.$t('shipped'),
          value: 'shipped'
        },
        {
          label: this.$t('cancel'),
          value: 'canceled'
        }
      ],
      filterCategoryStatus: 'all',
      loadingShippop: false,
      loadingZortout: false,

      showFilterShippopPackage: false,
      filterShippopPackages: [],
      currentPaymentID: null,
      showPreview: false,
      paymentFilter: [],
      shippoptimestamp: dayjs().format('x'),
      filterPackhaiPackages: [],
      filterSokochanPackages: [],
      sokochantimestamp: dayjs().format('x'),
      packhaitimestamp: dayjs().format('x'),
      showFilterPackhaiPackage: false,
      showFilterSokochanPackage: false,
      showAdvance: false,
      social: [],
      socialOptions: [],
      coupon: '',
      adminName: '',
      orderNumbers: [],
      menuVisible: false,
      hasSalePage: false,
      isActiveFilter: false,
      filterCreatedBy: []
      // filterStatus: ['pending', 'ordered', 'paid', 'shipped', 'canceled']
    }
  },
  components: {
    LineMyShopSummary,
    ManageOrderno,
    ExportInvoice,
    datepicker,
    Editable,
    SummaryItem,
    OrderSummaryMobile,
    ShopProfile,
    ModalHelp,
    Multiselect,
    PrintAllCovers,
    PrintAllCoversCentral,
    PrintAllCoversMonobo,
    ForexSummaryItem,
    MonoboSummaryItem,
    SelectShippopCourier,
    ShippopShipping,
    ShippingAddress,
    PrintChillBill,
    DateFilter,
    PackhaiShipping,
    SokochanShipping,
    ShippingScg,
    ShippingJt,
    ShippingNinja,
    customizeOrderSummary
  },
  computed: {
    isCentralLive() {
      return this.$store.state.centralPage.includes(this.selectedBot.pageid)
    },
    checkSelected() {
      console.log(this.selectedBot)
    },
    filteredShipping() {
      let vm = this
      // let count = 0
      // try {
      //   count = vm.summary.filter(v => v.shippingtype == el.name).length
      // } catch (error) {}
      let options = vm.shippingOptions.map(el => {
        let name = ''
        if (el.name.includes('_charge') && el.name.includes('other')) {
          name = el['4']
        } else {
          name = vm.$t(el.name)
        }
        return {
          name: name,
          value: el.name,
          count: vm.summary.filter(v => v.shippingtype == el.name).length
        }
      })

      options.push({
        name: vm.$t('Shippop'),
        value: 'shippop',
        count: vm.summary.filter(v => ['booking', 'waiting', 'confirm'].includes(v.shippop_status))
          .length
      })

      if (this.selectedBot.pageid == '145969602635827') {
        options.push({
          name: vm.$t('ควบคุมอุณหภูมิ'),
          value: 'ควบคุมอุณหภูมิ',
          count: vm.summary.filter(v => {
            try {
              let cart = JSON.parse(v.productdetail)
              // ควบคุมอุณหภูมิ
              let chiffon = cart.filter(p => {
                return ['23502'].includes(p.categoryid.toString())
              })
              return chiffon.length > 0
            } catch (error) {
              return false
            }
          }).length
        })
      }

      return options
    },
    filterPayment() {
      return [
        {
          name: this.$t('Bank Transfer'),
          value: 'transfer',
          count: this.summary.filter(v => v.payment == 'transfer' || v.payment == 'banktransfer')
            .length
        },
        {
          name: this.$t('cod_charge'),
          value: 'cod',
          count: this.summary.filter(v => v.payment == 'cod').length
        },
        {
          name: this.$t('Qr Code'),
          value: 'qrcode',
          count: this.summary.filter(v => v.payment == 'qrcode').length
        },
        {
          name: this.$t('Mobile Banking'),
          value: 'fbpay',
          count: this.summary.filter(v => v.payment == 'fbpay').length
        },
        {
          name: this.$t('PayPal'),
          value: 'credit',
          count: this.summary.filter(v => v.payment == 'credit').length
        },
        {
          name: this.$t('Credit card'),
          value: 'gbcredit',
          count: this.summary.filter(v => v.payment == 'gbcredit').length
        }
      ]
      // .filter(el => {
      //   return el.count > 0
      // })
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      getPageProfile: 'getPageProfile',
      currentLang: 'currentLang'
    }),
    pageCount: function() {
      // let sum = 0
      // this.filterStatus.forEach(status => {
      //   this.badge[status]
      //   sum += this.badge[status]
      // })
      let l = this.badge[this.filterStatus]
      // let l = sum
      let s = this.size
      return Math.ceil(l / s)
    },
    filterSummary() {
      let { orders, badges } = this.filterOrdersBy()
      this.badge = badges

      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size

      return orders.slice(start, end)
    },

    filterSummaryShippop() {
      let { orders, badges } = this.filterOrdersBy('shippop')
      this.badge = badges

      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size

      return orders.slice(start, end)
    },
    filterSummaryAllPage: function() {
      let { orders } = this.filterOrdersBy()
      return orders
    },
    filterOrders: function() {
      let { orders } = this.filterOrdersBy()
      if (this.cbAll.length) {
        return orders.filter(el => this.cbAll.includes(el.id))
      } else {
        return orders
      }
    },
    socialItems() {
      return this.socialOptions.map(social => {
        return {
          ...social,
          disabled: this.createBillType === 'conversion' && social.value === 'salepage'
        }
      })
    },
    createdByItems() {
      return [
        { value: 'admin', text: this.$t('admin_bill') },
        { value: 'customer', text: this.$t('customer_bill') },
        { value: 'conversion', text: this.$t('chat_bill') }
      ]
    }
    // statusItems() {
    //   return [
    //     { value: 'pending', text: this.$t('pending') },
    //     { value: 'ordered', text: this.$t('ordered') },
    //     { value: 'paid', text: this.$t('paid') },
    //     { value: 'shipped', text: this.$t('shipped') },
    //     { value: 'canceled', text: this.$t('cancel') }
    //   ]
    // }
  },
  async mounted() {
    const vm = this
    vm.loading = true
    const orders = await this.getOrderSummary()
    await this.getShipping()
    vm.convertOrder(orders)
    await vm.$nextTick()
    vm.loading = false
    await vm.$store.dispatch('loadPageProfile')
    if (vm.isCentralLive) {
      vm.getCategories()
    }

    if (vm.selectedBot.lalamove_info && vm.selectedBot.lalamove_info.status)
      vm.$store.dispatch('loadShippingcostdistance')
    const packages = this.selectedBot.packages
    if (packages.includes('facebook')) {
      vm.social.push('facebook')
      vm.socialOptions.push({ text: 'facebook', value: 'facebook' })
    }
    if (packages.includes('line')) {
      vm.social.push('line')
      vm.socialOptions.push({ text: 'line', value: 'line' })
    }
    if (packages.includes('instagram')) {
      vm.social.push('instagram')
      vm.socialOptions.push({ text: 'instagram', value: 'instagram' })
    }
    if (packages.includes('whatsapp')) {
      vm.social.push('whatsapp')
      vm.socialOptions.push({ text: 'whatsapp', value: 'whatsapp' })
    }
    if (packages.includes('google')) {
      vm.social.push('google')
      vm.socialOptions.push({ text: 'google', value: 'google' })
    }
    vm.social.push('salepage')
    vm.socialOptions.push({ text: 'salepage', value: 'salepage' })
  },
  filters: {
    formatdate: function(value) {
      return dayjs(value).format('YYYY/MM/DD h:mm:ss a')
    }
  },
  methods: {
    async dialogZortoutOpen() {
      const vm = this
      let selected = vm.summary.filter(el => {
        return this.cbAll.includes(el.id) && ['paid'].includes(el.status) && el.zortout_ref == null
      })
      selected = selected.map(item => item.id)
      if (selected.length == 0) {
        await vm.$swal({
          title: vm.$t('send_with_zortout_paid_only'),
          type: 'warning',
          confirmButtonText: vm.$t('Confirm')
        })
      } else {
        if (vm.$store.state.drJillPage.includes(vm.selectedBot.pageid)) {
          vm.shipWithZortout()
        } else {
          vm.dialogZortout = true
        }
      }
    },
    selectOrderBy(type) {
      const vm = this
      vm.orderBy = type
    },
    clearAllSearch() {
      const vm = this
      vm.coupon = ''
      vm.adminName = ''
      vm.createBillType = 'all'
      vm.orderNumbers = []
      vm.hasSalePage = false
      vm.social = vm.socialOptions.map(social => social.value)
      if (vm.isActiveFilter) {
        this.onRefresh()
      }
      vm.showAdvance = false
    },
    filterOrdersBy(type) {
      const vm = this
      var summary = []
      if (type === 'shippop') {
        summary = vm.summaryShippop
      } else {
        summary = vm.summary
      }
      let filter = cloneDeep(summary),
        orders = []
      try {
        if (vm.search && vm.search != '') {
          filter = filter.filter(function(el) {
            return (
              (el.remark && el.remark.toLowerCase().includes(vm.search.toLowerCase())) ||
              el.first_name.toLowerCase().includes(vm.search.toLowerCase()) ||
              el.last_name.toLowerCase().includes(vm.search.toLowerCase()) ||
              `${el.first_name} ${el.last_name}`.toLowerCase().includes(vm.search.toLowerCase()) ||
              el.id.toLowerCase().includes(vm.search.toLowerCase()) ||
              el.productdetail.toLowerCase().includes(vm.search.toLowerCase()) ||
              (el.nameaddress && el.nameaddress.toLowerCase().includes(vm.search.toLowerCase())) ||
              (el.akita_order_ref &&
                el.akita_order_ref.toLowerCase().includes(vm.search.toLowerCase())) ||
              (el.shippop_tracking_code &&
                el.shippop_tracking_code.toLowerCase().includes(vm.search.toLowerCase()))
            )
          })
        }

        // if (vm.coupon && vm.coupon != '') {
        //   filter = filter.filter(el => {
        //     try {
        //       if (el.jsonvalue == '') return false
        //       let jsondata = JSON.parse(el.jsonvalue)
        //       let couponcode = jsondata.promocode ? jsondata.promocode : ''
        //       return (
        //         couponcode &&
        //         vm.coupon &&
        //         couponcode.toLowerCase().includes(vm.coupon.toLowerCase())
        //       )
        //     } catch (error) {
        //       console.error(error)
        //       return false
        //     }
        //   })
        // }

        // if (vm.adminName && vm.adminName != '') {
        //   filter = filter.filter(el => {
        //     try {
        //       if (el.created_by_type !== 'admin') return false
        //       return el.created_by_name.toLowerCase().includes(vm.adminName.toLowerCase())
        //     } catch (error) {
        //       console.error(error)
        //       return false
        //     }
        //   })
        // }

        // if (vm.social && vm.social.length > 0) {
        //   filter = filter.filter(el => {
        //     if (
        //       vm.social.indexOf('facebook') != -1 &&
        //       el.app == 'facebook' &&
        //       el.userid != 'salepage'
        //     ) {
        //       return true
        //     }
        //     if (vm.social.indexOf('whatsapp') != -1 && el.app == 'whatsapp') {
        //       return true
        //     }
        //     if (vm.social.indexOf('google') != -1 && el.app == 'google') {
        //       return true
        //     }
        //     if (vm.social.indexOf('salepage') != -1 && el.userid == 'salepage') {
        //       return true
        //     }
        //     if (vm.social.indexOf('line') != -1 && el.app == 'line') {
        //       return true
        //     }
        //     if (
        //       vm.social.indexOf('instagram') != -1 &&
        //       ['instagram', 'instagram'].includes(el.app)
        //     ) {
        //       return true
        //     }
        //     if (
        //       vm.social.indexOf('other') != -1 &&
        //       ![
        //         'facebook',
        //         'line',
        //         'instagram',
        //         'instagram',
        //         'salepage',
        //         'google',
        //         'whatsapp'
        //       ].includes(el.app)
        //     ) {
        //       return true
        //     }
        //     return false
        //   })
        // }

        // if (vm.createBillType !== 'all') {
        //   filter = filter.filter(el => {
        //     if (vm.createBillType === 'admin') {
        //       return el.created_by_type === 'admin'
        //     } else if (vm.createBillType === 'customer') {
        //       return el.created_by_type === 'customer'
        //     } else if (vm.createBillType === 'conversion') {
        //       return el.created_by_type === 'conversion'
        //     }
        //     return false
        //   })
        // }

        if (vm.filterCreatedBy.length) {
          filter = filter.filter(el => {
            return vm.filterCreatedBy.map(item => item.value).includes(el.created_by_type)
          })
        }

        if (vm.shippingFilter.length) {
          filter = filter.filter(el => {
            if (vm.selectedBot.pageid == '145969602635827') {
              let isForzen = vm.shippingFilter.some(v => v.value == 'ควบคุมอุณหภูมิ')
              if (isForzen) {
                try {
                  let cart = JSON.parse(el.productdetail)
                  // ควบคุมอุณหภูมิ
                  let chiffon = cart.filter(p => {
                    return ['23502'].includes(p.categoryid.toString())
                  })
                  return chiffon.length > 0
                } catch (error) {
                  return false
                }
              }
            }

            return vm.shippingFilter.some(
              v => (v.value == 'shippop' && el.shippop_status != null) || el.shippingtype == v.value
            )
          })
        }

        if (vm.paymentFilter.length) {
          filter = filter.filter(el => {
            return vm.paymentFilter.some(v => el.payment == v.value)
          })
        }
      } catch (error) {
        console.error(error)
      }

      let badges = {
        all: 0,
        pending: 0,
        canceled: 0,
        ordered: 0,
        paid: 0,
        shipped: 0
      }
      try {
        badges.all = filter.length

        orders = filter.filter(val => {
          badges[val.status] += 1
          // return vm.filterStatus.includes(val.status)
          if (vm.filterStatus == 'all') return true
          else return val.status == vm.filterStatus
        })

        orders = orders.filter(val => {
          if (vm.filterCategoryStatus == 'all') return true
          else return val.livename == vm.filterCategoryStatus
        })
      } catch (error) {
        console.error(error)
      }

      return { orders, badges }
    },
    onShowProductDetail(payload) {
      this.showProductDetail = payload
    },
    async shipWithZortout() {
      const vm = this
      let selected = vm.summary.filter(el => {
        return this.cbAll.includes(el.id) && ['paid'].includes(el.status) && el.zortout_ref == null
      })
      selected = selected.map(item => item.id)
      if (selected.length == 0) {
        await vm.$swal({
          title: vm.$t('send_with_zortout_paid_only'),
          type: 'warning',
          confirmButtonText: vm.$t('Confirm')
        })
      } else {
        vm.createOrderZortout(selected)
        vm.dialogZortout = false
      }
    },
    async checkZortoutCreateOrder(selected) {
      try {
        let response = await this.post(`zortout/${this.selectedBot.pageid}/check-create-order`, {
          order_ids: selected
        })
        if (response.success) {
          let data = response.result
          let isPending = data.some(i => i.status.includes('PENDING'))
          if (isPending) {
            this.zortoutOrder.status = 'PENDING'
          } else {
            let isFailed = data.some(i => i.status.includes('FAILED'))
            if (isFailed) {
              this.zortoutOrder.status = 'FAILED'
            } else {
              this.zortoutOrder.status = 'SUCCESS'
            }
          }
        }
        return response.result
      } catch (error) {
        throw error
      }
    },
    async createOrderZortout(selected) {
      try {
        this.$store.dispatch('loading')
        let response = await this.post(`zortout/${this.selectedBot.pageid}/create-order`, {
          order_ids: selected,
          select_vat_type: this.$store.state.drJillPage.includes(this.selectedBot.pageid)
            ? 3
            : this.zortout_select_vat_type
        })
        if (response.success) {
          await this.checkZortoutCreateOrder(selected)
          this.zortoutOrder.show = true

          this.zortoutOrder.status = 'PENDING'
          this.zortoutOrder.interval = setInterval(async () => {
            let responseCreateOrder = await this.checkZortoutCreateOrder(selected)
            if (this.zortoutOrder.status == 'SUCCESS') {
              this.$store.dispatch('loading')
              if (this.zortoutOrder.interval) clearInterval(this.zortoutOrder.interval)
              await this.$swal.fire({
                title: this.$t('Success'),
                type: 'success',
                confirmButtonText: this.$t('Confirm'),
                showCancelButton: false,
                reverseButtons: true
              })
              window.location.reload()
            } else if (this.zortoutOrder.status == 'FAILED') {
              let dataFailed = []
              responseCreateOrder.map(item => {
                if (item.status === 'FAILED') {
                  dataFailed.push(item.orderid)
                }
              })

              this.$store.dispatch('loading')
              if (this.zortoutOrder.interval) clearInterval(this.zortoutOrder.interval)

              await this.$swal.fire({
                title: this.$t('Error'),
                text: `ไม่สามารถจัดส่งออเดอร์ดังต่อไปนี้ได้ ${dataFailed.toString()}`,
                type: 'error',
                confirmButtonText: this.$t('Confirm'),
                showCancelButton: false,
                reverseButtons: true
              })
            }
          }, 5000)
        }
      } catch (error) {
        console.log(error)
        if (error.response && error.response.data.message == 'IMPORT_LIMIT_EXCEEDED') {
          await this.$swal.fire({
            title: this.$t('ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้งหลังจาก 10 นาที'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        } else {
          await this.$swal.fire({
            title: this.$t('Something went wrong. Please try it again later'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        }
      }
    },
    async shipWithShippop() {
      var selected = this.summary.filter(el => {
        return (
          this.cbAll.includes(el.id) &&
          ['ordered', 'paid'].includes(el.status) &&
          el.shippop_status == null
        )
      })
      if (selected.length == 0) {
        await this.$swal({
          title: 'กรุณาเลือกออเดอร์ที่ต้องการจัดส่ง',
          type: 'warning',
          confirmButtonText: this.$t('Confirm')
        })
      }
      //  else if (selected.length > 300) {
      //   await this.$swal({
      //     title: 'ไม่สามารถส่งกับทาง shippop เกิน 300 ออเดอร์ต่อหนึ่งการทำรายการ',
      //     type: 'warning',
      //     confirmButtonText: this.$t('Confirm')
      //   })
      // }
      else {
        this.filterShippopPackages = selected
        this.shippoptimestamp = dayjs().format('x')
        await this.$nextTick()
        this.showFilterShippopPackage = true
      }
    },
    async shipWithSokochan() {
      let out_charge = this.summary.filter(el => {
        return (
          this.cbAll.includes(el.id) &&
          ['ordered', 'paid'].includes(el.status) &&
          el.sokochan_ref == null &&
          ![
            'normal_charge',
            'kerry_charge',
            'ems_charge',
            'cod_charge',
            'kerry1d_charge',
            'kerry2d_charge'
          ].includes(el.shippingtype)
        )
      })

      if (out_charge.length > 0) {
        out_charge = out_charge
          .reduce((prev, curr) => {
            if (prev.indexOf(curr.shippingtype) == -1) prev.push(curr.shippingtype)
            return prev
          }, [])
          .reduce((prev, curr) => {
            prev = prev + `- ${this.$t(curr)}<br>`
            return prev
          }, '')
        await this.$swal({
          title: 'กรุณาเลือกขนส่งใหม่ เนื่องจากบางขนส่งไม่สามารถจัดส่งได้',
          html: out_charge,
          type: 'warning',
          confirmButtonText: this.$t('Confirm')
        })
        return false
      }
      var selected = this.summary.filter(el => {
        return (
          this.cbAll.includes(el.id) &&
          ['ordered', 'paid'].includes(el.status) &&
          el.sokochan_ref == null &&
          [
            'normal_charge',
            'kerry_charge',
            'ems_charge',
            'cod_charge',
            'kerry1d_charge',
            'kerry2d_charge'
          ].includes(el.shippingtype)
        )
      })
      if (selected.length == 0) {
        await this.$swal({
          title: 'กรุณาเลือกออเดอร์ที่ต้องการจัดส่ง',
          type: 'warning',
          confirmButtonText: this.$t('Confirm')
        })
      } else {
        this.filterSokochanPackages = selected
        this.sokochantimestamp = dayjs().format('x')
        await this.$nextTick()
        this.showFilterSokochanPackage = true
      }
    },
    async shipWithPackhai() {
      let out_charge = this.summary.filter(el => {
        return (
          this.cbAll.includes(el.id) &&
          ['ordered', 'paid'].includes(el.status) &&
          el.packhai_ref == null &&
          ![
            'bestexpress_charge',
            'kerry_charge',
            'ems_charge',
            'nim_charge',
            'flash_charge',
            'scgexpress_charge',
            'jtexpress_charge',
            'cod_charge'
          ].includes(el.shippingtype)
        )
      })

      if (out_charge.length > 0) {
        out_charge = out_charge
          .reduce((prev, curr) => {
            if (prev.indexOf(curr.shippingtype) == -1) prev.push(curr.shippingtype)
            return prev
          }, [])
          .reduce((prev, curr) => {
            prev = prev + `- ${this.$t(curr)}<br>`
            return prev
          }, '')
        await this.$swal({
          title: 'กรุณาเลือกขนส่งใหม่ เนื่องจากบางขนส่งไม่สามารถจัดส่งได้',
          html: out_charge,
          type: 'warning',
          confirmButtonText: this.$t('Confirm')
        })
        return false
      }
      var selected = this.summary.filter(el => {
        return (
          this.cbAll.includes(el.id) &&
          ['ordered', 'paid'].includes(el.status) &&
          el.packhai_ref == null &&
          [
            'bestexpress_charge',
            'kerry_charge',
            'ems_charge',
            'nim_charge',
            'flash_charge',
            'scgexpress_charge',
            'jtexpress_charge',
            'cod_charge'
          ].includes(el.shippingtype)
        )
      })
      if (selected.length == 0) {
        await this.$swal({
          title: 'กรุณาเลือกออเดอร์ที่ต้องการจัดส่ง',
          type: 'warning',
          confirmButtonText: this.$t('Confirm')
        })
      } else {
        this.filterPackhaiPackages = selected
        this.packhaitimestamp = dayjs().format('x')
        await this.$nextTick()
        this.showFilterPackhaiPackage = true
      }
    },
    closePreview() {
      location.reload()
    },

    changeShippingOption() {
      this.clearSelectAll()
      this.pageNumber = 1
    },
    changePaymentOption() {
      this.clearSelectAll()
      this.pageNumber = 1
    },
    async onPrinCover(allcontents, payload) {
      const vm = this
      let orders = []
      if (allcontents) {
        orders = await vm.getOrderForExport(payload.orderSelect)
      } else orders = vm.filterOrders
      // orders = orders.filter(el => {
      //   return ['paid'].includes(el.status)
      // })

      // Prevent printing a cover when some orders don't have an address
      if (
        !_(orders)
          .map('nameaddress')
          .every()
      ) {
        return this.$swal.fire({
          title: this.$t('Warning!'),
          text: this.$t('no_delivery_address_warning'),
          type: 'warning',
          confirmButtonText: this.$t('Confirm'),
          reverseButtons: true
        })
      }

      payload.printPdf(orders)
    },
    changeCategory(category) {
      this.filterCategoryStatus = category.name
      this.pageNumber = 1
    },
    getCategories() {
      api.getCategories({ pageid: this.selectedBot.pageid }, (err, response) => {
        if (response.responsecode == 200) {
          this.categories = response.categorylist
        }
      })
    },
    async onRefresh() {
      const vm = this
      vm.loading = true
      let orders = await vm.getOrderSummary()
      vm.convertOrder(orders)
      vm.loading = false
    },
    getShipping() {
      const vm = this
      return new Promise((resolve, reject) => {
        let data = { pageid: vm.selectedBot.pageid }
        api.getAllShipingCharge(data, (error, response) => {
          if (error) reject(error)

          let result = Object.keys(response.shippinglist).map(function(key) {
            return { name: key, ...response.shippinglist[key] }
          })

          result.push({ ...[0, true, [], 0], name: 'googlemap_charge' })
          result.push({ ...[0, true, [], 0], name: 'pickup_charge' })

          vm.shippingOptions = result
          vm.$store.state.shippinglist = response.shippinglist
          resolve()
        })
      })
    },
    assignCb(id) {
      if (this.cbAll.includes(id)) this.cbAll = this.cbAll.filter(v => id != v)
      else {
        this.cbAll.push(id)
      }
    },
    clickCbAll() {
      if (!this.cbAll.length) {
        this.cbAll = this.filterSummaryAllPage.map(v => v.id)
        this.checkboxAll = true
      } else {
        this.cbAll = []
        this.checkboxAll = false
      }
    },
    onConfirmCancelOrder(status) {
      const vm = this
      if (status.value == 'canceled') {
        vm.$swal
          .fire({
            title: vm.$t('do_you_want_cancel_order'),
            text: vm.$t('once_confirmed_the_status_cannot_be_changed_back'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
          .then(async result => {
            if (result.value) {
              vm.onSelectOrderStatus(status)
            } else {
              vm.status = ''
            }
          })
      } else {
        vm.onSelectOrderStatus(status)
      }
    },
    async onSelectOrderStatus(status) {
      let vm = this

      var orders = this.summary
        .filter(el => {
          // if (this.selectedBot.pagetype !== 'enterprise') {
          //   return this.cbAll.includes(el.id) && el.shippop_status == null
          // } else {
          return this.cbAll.includes(el.id) && el.status != 'canceled'
          // }
        })
        .map(el => {
          return el.id
        })

      if (orders.length == 0) {
        return false
      }
      let data = {
        status: status.value,
        orderid: orders,
        pageid: this.selectedBot.pageid
      }
      vm.$store.dispatch('loading')
      try {
        await vm.updateMultipleStatus(data)
      } catch (error) {
        console.error(error)
      }
      vm.$store.dispatch('loading')
    },

    async sokochanUpdateStatus(payload) {
      let { orders, oncomplete } = payload
      let data = {
        status: 'shipped',
        orderid: orders,
        pageid: this.selectedBot.pageid
      }
      await this.updateMultipleStatus(data)
      await this.$swal.fire({
        type: 'success',
        title: this.$t('Success')
      })
      if (oncomplete) oncomplete()
    },
    async packhaiUpdateStatus(payload) {
      let { orders, oncomplete } = payload
      let data = {
        status: 'shipped',
        orderid: orders,
        pageid: this.selectedBot.pageid
      }
      await this.updateMultipleStatus(data)
      await this.$swal.fire({
        type: 'success',
        title: this.$t('Success')
      })
      if (oncomplete) oncomplete()
    },
    updateMultipleStatus(data) {
      let vm = this
      return new Promise((resolve, reject) => {
        api.putmultistatusordersummary(data, async function(error, response) {
          if (error) reject(error)
          var promiseStatus = []
          let listIdstockAdd = []
          vm.summary
            .filter(el => el.status != 'canceled')
            .forEach(async el => {
              if (vm.cbAll.includes(el.id)) {
                if (vm.selectedBot.pageid != '1227843817265057') {
                  if (status.value != 'canceled' && el.status == 'canceled') {
                    promiseStatus.push(
                      new Promise((resolve, reject) => {
                        api.orderstockdelete({ orderid: el.id }, () => {
                          resolve()
                        })
                      })
                    )
                  } else if (el.status != 'canceled' && data.status == 'canceled') {
                    listIdstockAdd.push(el.id)
                  }
                }

                el.status = status.value
              }
            })
          if (listIdstockAdd.length > 0) {
            listIdstockAdd = listIdstockAdd.toString()
            await api.orderstockadd({ orderids: listIdstockAdd }, () => {
              vm.status = ''
              vm.onRefresh()
            })
          } else {
            await Promise.all(promiseStatus).finally(() => {
              vm.status = ''
              vm.onRefresh()
            })
          }
          resolve()
        })
      })
    },
    onClickPageinate: function(pageNum) {
      $('.vb-content').animate({
        scrollTop: 0
      })
    },
    onSelectedDate: async function(value) {
      this.pageNumber = 1
      this.loading = true
      var orders = await this.getOrderSummary()
      this.convertOrder(orders)
      this.loading = false
    },
    async loadSummary() {
      this.loading = true
      var orders = await this.getOrderSummary()
      this.convertOrder(orders)
      this.loading = false
    },

    async getOrderErrorShippop(order) {
      this.showFilterShippopPackage = false
      this.loading = true
      var orders = await this.getOrderSummary(true, true, order)
      this.convertOrder(orders, 'shippop')
      this.dialogShippop = true
      this.loading = false
    },
    changeStatus: function(value) {
      this.filterStatus = value
      this.pageNumber = 1
      this.clearSelectAll()
    },
    async getOrderForExport(orderSelect) {
      let vm = this
      var response = await this.getOrderSummary(true, true, orderSelect)
      var orders = []
      if (response.data) {
        orders = response.data
      }
      let filter = orders

      if (vm.search == '') {
        if (vm.filterStatus !== 'all') {
          filter = filter.filter(el => el.status == vm.filterStatus)
        }
        // filter = filter.filter(el => vm.filterStatus.includes(el.status))
      } else {
        filter = vm.summary.filter(function(el) {
          return (
            el.first_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.last_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.id.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.productdetail.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.nameaddress.toLowerCase().includes(vm.search.toLowerCase())
          )
        })
      }
      if (vm.shippingFilter.length) {
        filter = filter.filter(el => {
          return vm.shippingFilter.some(v => el.shippingtype == v.value)
        })
      }
      if (this.cbAll.length) {
        return filter.filter(el => this.cbAll.includes(el.id))
      } else {
        return filter
      }
    },
    clearSelectAll() {
      this.cbAll = []
      this.checkboxAll = false
    },
    getOrderSummary: function(allcontents, noclearselect, orderSelect) {
      let vm = this
      allcontents = allcontents ? allcontents : false

      return new Promise((resolve, reject) => {
        let data = {
          order_ids: orderSelect,
          pageid: vm.selectedBot.pageid,
          datefrom: dayjs(vm.selectedDate.start).format('YYYY-MM-DD HH:mm'),
          dateto: dayjs(vm.selectedDate.end).format('YYYY-MM-DD HH:mm'),
          status: 'all',
          allcontents: allcontents
        }
        // vm.$store.dispatch('loading')
        api.getOrderSummary(data, function(error, response) {
          if (error) {
            console.error(error)
            // vm.$store.dispatch('loading')
            reject()
            return
          }
          if (response.data) {
            if (!noclearselect) {
              vm.clearSelectAll()
            }
            // vm.clearAllSearch()
            resolve(response)
          }
          // vm.$store.dispatch('loading')
        })
      })
    },

    async filterOrderSummary() {
      this.$refs.comboboxOrderNumbers.blur()
      await new Promise(resolve => setTimeout(resolve, 200))
      this.$store.dispatch('loading')

      const dateFilter = this.$refs.dateFilter
      if (dateFilter) {
        dateFilter.resetFilter()
        this.isActiveFilter = true
      }

      const payload = {
        order_ids: [],
        pageid: this.selectedBot.pageid,
        datefrom: dayjs(this.selectedDate.start).format('YYYY-MM-DD HH:mm'),
        dateto: dayjs(this.selectedDate.end).format('YYYY-MM-DD HH:mm'),
        status: 'all',
        allcontents: false,
        filter_ids: this.orderNumbers.length ? this.orderNumbers.join(',') : undefined,
        filter_apps: this.social.length ? this.social.join(',') : undefined,
        filter_created_by: this.createBillType === 'all' ? undefined : this.createBillType,
        filter_admin_name:
          this.createBillType === 'all' || this.createBillType === 'admin'
            ? this.adminName || undefined
            : undefined,
        filter_promocode:
          this.createBillType !== 'conversion' ? this.coupon || undefined : undefined
      }
      await api.getOrderSummary(payload, (error, response) => {
        if (error) {
          console.error(error)
          this.$store.dispatch('loading')
          return
        }
        if (response.data) {
          this.convertOrder(response)
        }
      })
      this.$store.dispatch('loading')
      this.$nextTick(() => {
        this.showAdvance = false
      })
    },

    convertOrder(response, type) {
      if (type === 'shippop') {
        this.summaryShippop = response.data.map(el => {
          return {
            ...el,
            virual_timestamp: dayjs().format('x')
          }
        })
      } else {
        this.summary = response.data.map(el => {
          return {
            ...el,
            virual_timestamp: dayjs().format('x')
          }
        })
      }

      if (this.filterStatus == 'all') {
        this.badge = {
          all: response.all,
          canceled: response.canceled,
          ordered: response.ordered,
          paid: response.paid,
          shipped: response.shipped
        }
      }
    },
    onChangeStatus: function(id, payload) {
      let vm = this
      vm.updateOrder(id, { order: payload, type: 'save' })
    },
    updateOrder: async function(id, { order, type, isSendReason = false }, callback) {
      let vm = this
      if (order.employeeId) {
        order.remark = `${order.remark}{|}${order.employeeId}`
      }
      vm.$store.dispatch('loading')
      let order_index = vm.summary.findIndex(function(element) {
        return element.id === id.toString()
      })
      if (order_index != -1) {
        let data = cloneDeep(vm.summary[order_index])
        data = {
          ...data,
          ...order
        }

        if (data.note == 'base64') {
          delete data.note
        }

        if (type == 'send' && data.status == 'canceled') data.sendreason = true
        else if (type == 'send' && data.status == 'shipped') data.sendtrackingstatus = true
        data.trackingno = data.trackingno ? data.trackingno : ''
        if (!isSendReason) {
          data = _.omit(data, ['reason', 'sendreason'])
        }
        if (data) {
          api.editOrderSummary(data, function(error, response) {
            if (error) {
              console.error(error)
              vm.$store.dispatch('loading')
              return
            }

            if (response && response.result && response.result.note) {
              order.k_bank_verify_slip_json = response.result.k_bank_verify_slip_json
              order.k_bank_verify_slip_status_code = response.result.k_bank_verify_slip_status_code
            }

            vm.$set(vm.summary, order_index, order)
            // order.virual_timestamp = dayjs().format('x')
            if (callback) {
              callback()
            }

            vm.$store.dispatch('loading')
          })
        }
      } else {
        await this.$swal({
          title: 'ไม่เจอออเดอร์ที่ต้องการแก้ไข',
          type: 'error',
          confirmButtonText: this.$t('Confirm')
        })
      }
    },

    async exportOrderSummary(type) {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''
      let orders = []
      // await this.getOrderForExport()
      let filter = this.filterOrders
      let filename = ''
      var json = []

      filter.forEach(val => {
        // if (vm.filterStatus.includes(val.status)) {
        if (val.status == vm.filterStatus) {
          orders.push(val)
        } else if (vm.filterStatus == 'all') {
          orders.push(val)
        }
      })

      orders = orders.filter(val => {
        if (vm.filterCategoryStatus == 'all') return true
        else return val.livename == vm.filterCategoryStatus
      })

      if (vm.$aston.astonpages.includes(vm.selectedBot.pageid)) {
        orders.forEach((val, index) => {
          let note = val.note
          if (typeof note !== 'undefined' && note != null && note !== '') {
            try {
              note = JSON.parse(note)
            } catch (error) {
              return
            }
            var name, phone, address, zipcode, sku, sku2, sa_link, amount, proname
            name = phone = address = zipcode = sku = sku2 = sa_link = amount = proname = ''
            if (typeof note.name !== 'undefined') name = note.name
            if (typeof note.phone !== 'undefined') phone = note.phone
            if (typeof note.address !== 'undefined') address = note.address
            if (typeof note.zipcode !== 'undefined') zipcode = note.zipcode
            if (typeof note.sku !== 'undefined') {
              sku = note.sku
              var temp = sku.split('+')
              if (temp.length == 2) {
                sku = temp[0]
                sku2 = temp[1]
              }
            }
            if (typeof note.amount !== 'undefined') amount = note.amount
            // if (typeof note.proname !== 'undefined') proname = note.proname
            proname = val.productdetail
            if (typeof note.sa_link !== 'undefined' && !note.sa_link.includes('hatbot')) {
              sa_link = note.sa_link
            } else {
              if (
                vm.selectedBot.pageid == '1231805606976542' ||
                vm.selectedBot.pageid == '391365474996527' ||
                vm.selectedBot.pageid == '2105726733070683'
              ) {
                if (typeof note.sa_link !== 'undefined')
                  sa_link = note.sa_link + '-dc-bee-' + proname
              } else {
                if (typeof note.sa_link !== 'undefined') sa_link = note.sa_link + proname
              }
            }
            json.push({
              ลำดับ: index + 1,
              'Order No.': val.id,
              'ชื่อ-สกุล*': name,
              เบอร์โทร: phone,
              ที่อยู่: address,
              รหัสไปรษณีย์: zipcode,
              ไอดีสินค้า: sku,
              ไอดีสินค้า2: sku2,
              ชื่อสินค้า: proname,
              'ลิงก์ทำ order': sa_link,
              ราคาสินค้า: numeral(amount)
                .format('0,0.00')
                .toString(),
              หมายเหตุ: val.remark
            })
          }
        })
        filename = 'order_summary_' + dayjs().format('YYYY_MM_DD')
      } else {
        if (type == 'merge') {
          orders = orders.sort(
            (a, b) =>
              dayjs(b.timestamp).format('YYYYMMDDHHmm') - dayjs(a.timestamp).format('YYYYMMDDHHmm')
          )
          json = orders.map(val => {
            let productdetail = ''
            let sku = ''
            try {
              var products = JSON.parse(val.productdetail)
            } catch (error) {
              var products = val.productdetail
            }

            try {
              if (typeof products == 'object' && products.length > 0) {
                products.map(function(product) {
                  productdetail +=
                    product.name +
                    ' x ' +
                    product.quantity +
                    ` SKU:${product.sku ? product.sku : '- '}` +
                    (product.option ? ' (' + product.option + ')' : '') +
                    ' : ' +
                    (product.price > 0 ? '฿' + product.price : 'Free') +
                    '\r\n'

                  sku += `${product.sku}/`
                })
              } else {
                productdetail = val.productdetail
                sku = val.sku
              }
            } catch (error) {
              productdetail = val.productdetail
              sku = val.sku
            }

            var realname = val.nameaddress ? val.nameaddress.split(' , ') : []
            var shippingType = ''
            try {
              var jsondata = JSON.parse(val.shippingtype)
              if (jsondata.type) {
                shippingType = jsondata.type
              }
            } catch (error) {
              if (val.shippingtype && val.shippingtype.includes('other')) {
                var shipping = vm.shippingOptions.find(el => {
                  return el.name == val.shippingtype
                })
                shippingType = shipping ? shipping[4] : val.shippingtype
              } else {
                shippingType = val.shippingtype
              }
            }

            var couponcode = ''
            try {
              jsondata = JSON.parse(val.jsonvalue)
              couponcode = jsondata.promocode ? jsondata.promocode : ''
            } catch (error) {}

            return {
              'Order No.': val.id,
              Products: productdetail,
              Remark: val.remark,
              'Social Name': val.first_name + ' ' + val.last_name,
              'Real Name': realname.length > 1 ? realname[0] : '',
              Address: val.nameaddress,
              'Price Per Unit':
                Number(val.amount) &&
                Number(val.amount) > 0 &&
                Number(val.allquantity) &&
                Number(val.allquantity) > 0
                  ? numeral(Math.round((Number(val.amount) / Number(val.allquantity)) * 100) / 100)
                      .format('0,0.00')
                      .toString()
                  : 0,
              Price: numeral(val.amount)
                .format('0,0.00')
                .toString(),

              // } catch (error) {
              //   console.log(error)
              // }
              // let tax_detail = null
              // try {
              //   tax_detail = JSON.parse(val.address_json)
              // } catch (error) {
              //   console.log(error)
              // }
              // let shipping_address_json = null
              // try {
              //   shipping_address_json = JSON.parse(val.shipping_address_json)
              // } catch (error) {
              //   console.log(error)
              // }
              // let jsonDataAddon = null
              // let emailAddon = null
              // try {
              //   if (vm.selectedBot.shop_addon_form_status) {
              //     jsonDataAddon = JSON.parse(val.shop_addon_value_json)[3]
              //     emailAddon = JSON.parse(val.shop_addon_value_json)[2]
              //   }
              // } catch (error) {
              //   console.log(error)
              // }
              // let exportData = {
              //   'สร้างเมื่อ (Created Order at)': dayjs(val.timestamp).format('DD/MM/YYYY HH:mm'),
              //   'เลขที่การสั่งซื้อ (Order No.)': val.id,
              //   'ชื่อบัญชี (Profile Name)': `${val.first_name} ${val.last_name}`,
              //   'สร้างโดย (Created Order by)':
              //     val.created_by_type === 'admin'
              //       ? val.created_by_name
              //       : `${val.first_name} ${val.last_name}`,
              //   // 'สร้างโดยสถานะ (Created Order by type)' : val.created_by_type === 'admin'? 'Admin' : 'Customer',
              //   'สถานะ (Order Status)': val.status,
              //   'วิธีการชำระเงิน (Payment Method)': val.payment,
              //   'หมายเลขอ้างอิง (Transaction ID)': val.transactionid,
              //   'หลักฐานการชำระเงิน (Image Slip)': val.note ? val.note : '',
              //   'ชื่อสินค้า (Product Name)': productdetail,
              //   SKU: sku,
              //   'จำนวน (Quantity)': val.allquantity ? `${val.allquantity}` : '-',
              //   'ราคาสินค้า (Product Price)': numeral(val.full_product_price)
              // .format('0,0.00')
              // .toString(),
              Shipping: shippingType ? vm.$t(shippingType) : '',
              'Tracking No.': val.trackingno,
              'Created Date': dayjs(val.timestamp).format('DD/MM/YYYY HH:mm'),
              Status:
                vm.$store.getters.getPackage == 'premium' && val.userstatus ? val.userstatus : '-',
              Tags: vm.$store.getters.getPackage == 'premium' && val.tags ? val.tags : '-',
              SKU: products[0].sku ? `${products[0].sku}` : '-',
              Quantity: val.allquantity ? `${val.allquantity}` : '-',
              'Cutomer Code': couponcode,
              'Image Slip': val.note ? val.note : '',
              Channel: val.app ? val.app : ''
              // 'ราคาลดเหลือ (Discount Price)': numeral(
              //   parseInt(val.amount) + parseInt(val.discount) - parseInt(val.shippingcharge)
              // )
              //   .format('0,0.00')
              //   .toString(),
              // 'ค่าส่ง (Shipping Fee)': val.shippingcharge,
              // 'รหัสโค้ดส่วนลด (Coupon Code)': couponcode,
              // 'ส่วนลด (Coupon Discount)': numeral(val.discount)
              //   .format('0,0.00')
              //   .toString(),
              // 'ยอดรวมทั้งสิ้น (Total)': numeral(val.amount)
              //   .format('0,0.00')
              //   .toString(),
              // 'ข้อมูลในการออกใบเสร็จ/ใบกำกับภาษี (Receipt/ Tax invoice info)': tax_detail
              //   ? tax_detail.tax_address
              //   : '',
              // 'หมายเลยประจำตัวผู้เสียภาษี (Tax ID)': tax_detail ? tax_detail.tax_id : '',
              // 'ชื่อ-ที่อยู่ผู้รับ (Address)': val.nameaddress,
              // 'ชื่อผู้รับ (Customer Name)': realname.length > 1 ? realname[0] : '',
              // 'บ้านเลขที่ (House No.)': shipping_address_json.address,
              // 'แขวง/ตำบล (District)': shipping_address_json.district,
              // 'เขต/อำเภอ (Subdistrict)': shipping_address_json['sub-district'],
              // 'จังหวัด (Province)': shipping_address_json.province,
              // 'รหัสไปรษณีย์ (Postcode)': shipping_address_json.zipcode,
              // 'เบอร์โทรศัพท์ (Phone)': shipping_address_json.tel,
              // 'ช่องทางการจัดส่ง(Shipping)': shippingType ? vm.$t(shippingType) : '',
              // 'เลขพัสดุ(Tracking No.)': val.trackingno,
              // 'หมายเหตุ (Remark)': val.remark
              //  // Status:
              //  //   vm.$store.getters.getPackage == 'premium' && val.userstatus ? val.userstatus : '-',
              //  // Tags: vm.$store.getters.getPackage == 'premium' && val.tags ? val.tags : '-',
              // }
              // if(emailAddon && emailAddon.label){
              //   exportData[emailAddon.label] = emailAddon.message || ''
              // }
              // if(emailAddon && emailAddon.label){
              //   exportData[jsonDataAddon.label] = jsonDataAddon.message || ''
            }

            // return exportData
          })
          filename = 'zwizshop'
        } else if (type == 'separate') {
          // csvContent +=
          //   'Order No.,Status,SKU,Products,Price,Remark,Social Name,Real Name,Address,Price,Shipping,Tracking No.,Created Date,Status,Tags,Quantity' +
          //   '\r\n'
          orders = orders.sort(
            (a, b) =>
              dayjs(b.timestamp).format('YYYYMMDDHHmm') - dayjs(a.timestamp).format('YYYYMMDDHHmm')
          )
          orders.forEach(val => {
            var productdetail = []
            var productdetail2 = ''
            try {
              var products = JSON.parse(val.productdetail)
            } catch (error) {
              var products = val.productdetail
            }
            try {
              if (typeof products == 'object' && products.length > 0) {
                products.map(function(product) {
                  productdetail.push({
                    name: product.name ? product.name : '',
                    quantity: product.quantity,
                    sku: product.sku ? product.sku : '',
                    option: product.option ? ' (' + product.option + ')' : '',
                    price: product.price > 0 ? product.price : 'Free',
                    cart_remark: product.cart_remark
                    // full_price_per_unit: product.full_price_per_unit
                    //   ? product.full_price_per_unit
                    //   : ''
                  })
                  productdetail2 +=
                    product.name +
                    ' x ' +
                    product.quantity +
                    ` SKU:${product.sku ? product.sku : '- '}` +
                    (product.option ? ' (' + product.option + ')' : '') +
                    ' : ' +
                    (product.price > 0 ? '฿' + product.price : 'Free') +
                    '\r\n'
                })
              } else {
                productdetail[0] = val.productdetail
              }
            } catch (error) {
              productdetail[0] = val.productdetail
            }

            var realname = val.nameaddress ? val.nameaddress.split(' , ') : []
            let telephone = '',
              receiver_name = '',
              address = ''
            if (realname.length > 0) {
              if (realname.length > 1) {
                receiver_name = realname[0]
                realname.splice(0, 1)
              }

              let telephone_index = realname.findIndex(el => {
                return el.match(/^[0][0-9]{8,9}$/g)
              })

              if (telephone_index != -1) {
                telephone = realname[telephone_index]
                realname.splice(telephone_index, 1)
              }

              address = realname.join(',')
            }
            address = address || val.nameaddress
            var shippingType = ''
            try {
              var jsondata = JSON.parse(val.shippingtype)
              if (jsondata.type) {
                shippingType = jsondata.type
              }
            } catch (error) {
              if (val.shippingtype && val.shippingtype.includes('other')) {
                var shipping = vm.shippingOptions.find(el => {
                  return el.name == val.shippingtype
                })
                shippingType = shipping ? shipping[4] : val.shippingtype
              } else {
                shippingType = val.shippingtype
              }
            }

            var couponcode = ''
            let transactionid = val.transactionid ? val.transactionid : ''
            try {
              jsondata = JSON.parse(val.jsonvalue)
              couponcode = jsondata.promocode ? jsondata.promocode : ''
            } catch (error) {}

            let tax_detail = null
            try {
              tax_detail = JSON.parse(val.address_json)
            } catch (error) {
              // console.log(error)
            }
            // let shipping_address_json = null
            // try {
            //   shipping_address_json = JSON.parse(val.shipping_address_json)
            // } catch (error) {
            //   console.log(error)
            // }
            // let jsonDataAddon = null
            // let emailAddon = null
            // try {
            //   if (vm.selectedBot.shop_addon_form_status) {
            //     jsonDataAddon = JSON.parse(val.shop_addon_value_json)[3]
            //     emailAddon = JSON.parse(val.shop_addon_value_json)[2]
            //   }
            // } catch (error) {
            //   console.log(error)
            // }

            var row = {
              'Order No.': val.id,
              Products: productdetail2,
              Remark: val.remark,
              'Social Name': val.first_name + ' ' + val.last_name,
              'Real Name': realname.length > 1 ? realname[0] : '',
              Address: val.nameaddress,
              'Price Per Unit':
                Number(val.amount) &&
                Number(val.amount) > 0 &&
                Number(val.allquantity) &&
                Number(val.allquantity) > 0
                  ? numeral(Math.round((Number(val.amount) / Number(val.allquantity)) * 100) / 100)
                      .format('0,0.00')
                      .toString()
                  : 0,
              Price: numeral(val.amount)
                // 'สร้างเมื่อ (Created Order at)': dayjs(val.timestamp).format('DD/MM/YYYY HH:mm'),
                // 'เลขที่การสั่งซื้อ (Order No.)': val.id,
                // 'ชื่อบัญชี (Profile Name)': `${val.first_name} ${val.last_name}`,
                // 'สร้างโดย (Created Order by)':
                //   val.created_by_type === 'admin'
                //     ? val.created_by_name
                //     : `${val.first_name} ${val.last_name}`,
                // // 'สร้างโดยสถานะ (Created Order by type)' : val.created_by_type === 'admin'? 'Admin' : 'Customer',
                // 'สถานะ (Order Status)': val.status,
                // 'วิธีการชำระเงิน (Payment Method)': val.payment,
                // 'หมายเลขอ้างอิง (Transaction ID)': val.transactionid,
                // 'หลักฐานการชำระเงิน (Image Slip)': val.note ? val.note : '',
                // 'ชื่อสินค้า (Product Name)': productdetail2,

                // 'จำนวน (Quantity)': val.allquantity ? `${val.allquantity}` : '-',
                // 'ราคาสินค้า (Product Price)': numeral(val.full_product_price)
                .format('0,0.00')
                .toString(),
              Shipping: shippingType ? vm.$t(shippingType) : '',
              'Tracking No.': val.trackingno,
              'Created Date': dayjs(val.timestamp).format('DD/MM/YYYY HH:mm'),
              Status:
                vm.$store.getters.getPackage == 'premium' && val.userstatus ? val.userstatus : '-',
              Tags: vm.$store.getters.getPackage == 'premium' && val.tags ? val.tags : '-',
              SKU: products[0].sku ? `${products[0].sku}` : '-',
              Quantity: val.allquantity ? `${val.allquantity}` : '-',
              'Cutomer Code': couponcode,
              'Image Slip': val.note ? val.note : '',
              Channel: val.app ? val.app : ''
              // 'ราคาลดเหลือ (Discount Price)': numeral(
              //   parseInt(val.amount) + parseInt(val.discount) - parseInt(val.shippingcharge)
              // )
              //   .format('0,0.00')
              //   .toString(),
              // 'ค่าส่ง (Shipping Fee)': val.shippingcharge,
              // 'รหัสโค้ดส่วนลด (Coupon Code)': couponcode,
              // 'ส่วนลด (Coupon Discount)': numeral(val.discount)
              //   .format('0,0.00')
              //   .toString(),
              // 'ยอดรวมทั้งสิ้น (Total)': numeral(val.amount)
              //   .format('0,0.00')
              //   .toString(),
              // 'ข้อมูลในการออกใบเสร็จ/ใบกำกับภาษี (Receipt/ Tax invoice info)': tax_detail
              //   ? tax_detail.tax_address
              //   : '',
              // 'หมายเลยประจำตัวผู้เสียภาษี (Tax ID)': tax_detail ? tax_detail.tax_id : '',
              // 'ชื่อ-ที่อยู่ผู้รับ (Address)': val.nameaddress,
              // 'ชื่อผู้รับ (Customer Name)': realname.length > 1 ? realname[0] : '',
              // 'บ้านเลขที่ (House No.)': shipping_address_json.address,
              // 'แขวง/ตำบล (District)': shipping_address_json.district,
              // 'เขต/อำเภอ (Subdistrict)': shipping_address_json['sub-district'],
              // 'จังหวัด (Province)': shipping_address_json.province,
              // 'รหัสไปรษณีย์ (Postcode)': shipping_address_json.zipcode,
              // 'เบอร์โทรศัพท์ (Phone)': shipping_address_json.tel,
              // 'ช่องทางการจัดส่ง(Shipping)': shippingType ? vm.$t(shippingType) : '',
              // 'เลขพัสดุ(Tracking No.)': val.trackingno,
              // 'หมายเหตุ (Remark)': val.remark
            }
            try {
              let split_address = address.split(',')
              split_address.forEach((val, index) => (row['Address ' + (index + 1)] = val))
            } catch (error) {}
            // if(emailAddon && emailAddon.label){
            //   row[emailAddon.label] = emailAddon.message || ''
            // }
            // if(emailAddon && emailAddon.label){
            //   row[jsonDataAddon.label] = jsonDataAddon.message || ''
            // }

            json.push(row)

            if (productdetail.length > 1) {
              productdetail.map((detail, dindex) => {
                json.push({
                  // ['ชื่อสินค้า (Product Name)']:
                  Products:
                    detail.name +
                    ' x ' +
                    detail.quantity +
                    ` SKU:${detail.sku ? detail.sku : '- '}` +
                    (detail.option ? ' (' + detail.option + ')' : '') +
                    ' : ' +
                    (detail.price > 0 ? '฿' + detail.price : 'Free') +
                    '\r\n',
                  Price: numeral(detail.price)
                    // ['ราคาสินค้า (Product Price)']: numeral(
                    //   detail.full_price_per_unit * detail.quantity
                    // )
                    //   .format('0,0.00')
                    //   .toString(),
                    // ['ราคาลดเหลือ (Discount Price)']: numeral(detail.price)
                    .format('0,0.00')
                    .toString(),
                  Quantity: detail.quantity
                  // ['จำนวน (Quantity)']: detail.quantity.toString()
                })
              })
            }
          })
          filename = 'zwizshop'
        } else if (type == 'kerry') {
          orders = orders.sort(
            (a, b) =>
              dayjs(a.timestamp).format('YYYYMMDDHHmm') - dayjs(b.timestamp).format('YYYYMMDDHHmm')
          )
          $.each(orders, function(index, val) {
            let shipping_address_json = null
            try {
              shipping_address_json = JSON.parse(val.shipping_address_json)
            } catch (error) {
              console.log(error)
            }
            var postcode = ''
            var phone = ''
            var name = ''
            var address = val.nameaddress ? val.nameaddress.split(' , ') : []
            var result_address = ''

            var shippingType = ''
            try {
              var jsondata = JSON.parse(val.shippingtype)
              if (jsondata.type) {
                shippingType = jsondata.type
              }
            } catch (error) {
              shippingType = val.shippingtype
            }
            var price =
              shippingType == 'cod_charge'
                ? numeral(val.amount)
                    .format('0,0')
                    .toString()
                : 0
            if (address.length > 0) {
              name = address[0]
              address.splice(0, 1)
              phone = address[address.length - 1]
              address.splice(address.length - 1, 1)
              result_address = address.join('')
              var postcode_regex = /[0-9]{5}/g
              if (
                (!shipping_address_json || !shipping_address_json.zipcode) &&
                result_address &&
                result_address.match(postcode_regex)
              ) {
                var postcode_match = result_address.match(postcode_regex)
                if (postcode_match.length > 0) {
                  postcode = postcode_match[0]
                  result_address = result_address.replace(postcode, '')
                }
              } else {
                postcode = shipping_address_json ? shipping_address_json.zipcode || '' : ''
              }
            }
            let productdetail = ''
            try {
              var products = JSON.parse(val.productdetail)
            } catch (error) {
              var products = val.productdetail
            }
            try {
              if (products && products.length > 0) {
                products.map((product, index) => {
                  productdetail += `${product.name || ''} x ${product.quantity || ''} ${
                    index !== products.length - 1 ? '&&' : ''
                  } `
                })
              }
            } catch (error) {
              console.log(error)
            }
            json.push({
              No: index + 1,
              'Recipient Name': name,
              'Mobile No.': phone,
              Email: '',
              'Address #1': address[0] || '',
              'Address #2': `${address[1] || ''} ${address[2] || ''} ${address[3] || ''}`,
              'Zip Code': postcode,
              'COD Amt (Baht)': price,
              Remark: val.remark || '',
              'Ref #1': val.id || '',
              'Ref #2': productdetail,
              'Sender Ref': ''
            })
          })
          filename = 'zwizshop_kerry'
        } else if (type == 'sap') {
          vm.sapFormat(filter)
          return false
        } else {
          // csvContent +=
          //   'Order No.,Status,SKU,Products,Price,Remark,Social Name,Real Name,Address,Price,Shipping,Tracking No.,Created Date,Status,Tags,Quantity' +
          //   '\r\n'
          orders = orders.sort(
            (a, b) =>
              dayjs(b.timestamp).format('YYYYMMDDHHmm') - dayjs(a.timestamp).format('YYYYMMDDHHmm')
          )
          orders.forEach(val => {
            var productdetail = []
            try {
              var products = JSON.parse(val.productdetail)
            } catch (error) {
              var products = val.productdetail
            }
            try {
              if (typeof products == 'object' && products.length > 0) {
                products.map(function(product) {
                  productdetail.push({
                    name: product.name ? product.name : '',
                    quantity: product.quantity,
                    sku: product.sku ? product.sku : '',
                    option: product.option ? ' (' + product.option + ')' : '',
                    price: product.price > 0 ? product.price : 'Free',
                    cart_remark: product.cart_remark
                  })
                })
              } else {
                productdetail[0] = val.productdetail
              }
            } catch (error) {
              productdetail[0] = val.productdetail
            }

            var realname = val.nameaddress ? val.nameaddress.split(' , ') : []
            let telephone = '',
              receiver_name = '',
              address = ''
            if (realname.length > 0) {
              if (realname.length > 1) {
                receiver_name = realname[0]
                realname.splice(0, 1)
              }

              let telephone_index = realname.findIndex(el => {
                return el.match(/^[0][0-9]{8,9}$/g)
              })

              if (telephone_index != -1) {
                telephone = realname[telephone_index]
                realname.splice(telephone_index, 1)
              }

              address = realname.join(',')
            }
            address = address || val.nameaddress
            var shippingType = ''
            try {
              var jsondata = JSON.parse(val.shippingtype)
              if (jsondata.type) {
                shippingType = jsondata.type
              }
            } catch (error) {
              if (val.shippingtype && val.shippingtype.includes('other')) {
                var shipping = vm.shippingOptions.find(el => {
                  return el.name == val.shippingtype
                })
                shippingType = shipping ? shipping[4] : val.shippingtype
              } else {
                shippingType = val.shippingtype
              }
            }

            var couponcode = ''
            let transactionid = val.transactionid ? val.transactionid : ''
            try {
              jsondata = JSON.parse(val.jsonvalue)
              couponcode = jsondata.promocode ? jsondata.promocode : ''
            } catch (error) {}

            let tax_detail = null
            try {
              tax_detail = JSON.parse(val.address_json)
            } catch (error) {}
            const status = val.status
              ? this.$t(val.status)
                  .charAt(0)
                  .toUpperCase() + this.$t(val.status).slice(1)
              : ''
            var row = {
              'Date & Time': dayjs(val.timestamp).format('DD/MM/YYYY HH:mm'),
              'Order Number': val.id,
              'Status Order': status,
              'Total per Order': val.allquantity ? `${val.allquantity}` : '-',
              SKU: typeof productdetail[0] == 'string' ? products[0].sku : productdetail[0].sku,
              Products:
                typeof productdetail[0] == 'string'
                  ? productdetail[0]
                  : `${productdetail[0].name}${
                      productdetail[0].option ? ` ${productdetail[0].option}` : ''
                    }`,
              'SKU Amount':
                typeof productdetail[0] == 'string'
                  ? productdetail[0].quantity
                  : products[0].quantity,
              Price:
                typeof productdetail[0] == 'string'
                  ? ''
                  : numeral(productdetail[0].price).format('0,0.00'),
              'Shipping fee': numeral(val.shippingcharge)
                .format('0,0.00')
                .toString(),
              Discount: numeral(val.discount)
                .format('0,0.00')
                .toString(),
              'Price Per Unit':
                Number(val.amount) &&
                Number(val.amount) > 0 &&
                Number(val.allquantity) &&
                Number(val.allquantity) > 0
                  ? numeral(Math.round((Number(val.amount) / Number(val.allquantity)) * 100) / 100)
                      .format('0,0.00')
                      .toString()
                  : 0,
              Total: numeral(val.amount)
                .format('0,0.00')
                .toString(),
              Shipping: shippingType ? vm.$t(shippingType) : '',
              'Tracking No.': val.trackingno,
              'Transaction ID': transactionid,
              'ShippopTracking No.': vm.selectedBot.shippop_status
                ? val.shippop_tracking_code
                : '-',
              Remark: val.remark != null ? val.remark : '',
              Channel: val.app,
              'Social Name': val.first_name + ' ' + val.last_name,
              'Real Name': receiver_name,
              'Tel.': telephone,
              Address: address,
              'Full Address': val.nameaddress,
              Status:
                vm.$store.getters.getPackage == 'premium' && val.userstatus ? val.userstatus : '-',
              'Customer Tags':
                vm.$store.getters.getPackage == 'premium' && val.tags ? val.tags : '-',
              'Cutomer Code': couponcode,
              'Tax ID': tax_detail ? tax_detail.tax_id : '',
              'Tax Address': tax_detail ? tax_detail.tax_address : '',
              'Issue Date': tax_detail
                ? dayjs(tax_detail.invoice_date).format('DD/MM/YYYY HH:mm')
                : '',
              'Image Slip': val.note ? val.note : '',
              Channel: val.app ? val.app : ''
            }

            try {
              let jsonDataAddon = null
              let emailAddon = null
              jsonDataAddon = JSON.parse(val.shop_addon_value_json)[3]
              emailAddon = JSON.parse(val.shop_addon_value_json)[2]
              if (vm.selectedBot.shop_addon_form_status) {
                row[jsonDataAddon.label] = jsonDataAddon.message
                row[emailAddon.label] = emailAddon.message
              }
            } catch (error) {
              console.log(error)
            }
            if (
              [
                '148831989096546',
                '1229692217050821',
                '135565533158593',
                '488563718210335',
                '799590883441878'
              ].includes(vm.selectedBot.pageid)
            ) {
              var remarksplit = []
              try {
                remarksplit = val.remark.split(';;')
                row.Remark = remarksplit[0]
                row['Bank Name'] = remarksplit.length > 1 ? remarksplit[1] : ''
              } catch (error) {
                row.Remark = val.remark
              }
            }

            if (
              ['176922345693076', '809510349133469', '103876431747147'].includes(
                vm.selectedBot.pageid
              )
            ) {
              var order = productdetail.find(el => {
                return el.cart_remark != '' || el.cart_remark != null
              })
              if (order) {
                row['ขายโดย'] = order.cart_remark
              }
            }

            if (vm.$store.state.centralPage.includes(vm.selectedBot.pageid)) {
              row['Live name'] = val.livename
              row['สถานะออเดอร์'] = val.order_tags
            }

            try {
              let split_address = address.split(',')
              split_address.forEach((val, index) => (row['Address ' + (index + 1)] = val))
            } catch (error) {}

            json.push(row)

            if (productdetail.length > 1) {
              productdetail.map((detail, dindex) => {
                if (dindex != 0) {
                  json.push({
                    SKU: detail.sku,
                    Products: `${detail.name}${detail.option ? ` ${detail.option}` : ''}`,
                    Price: numeral(detail.price).format('0,0.00'),
                    'SKU Amount': detail.quantity
                  })
                }
              })
            }
          })
          filename = 'zwizshop'
        }
      }
      var dataWS = null
      if (type == 'kerry') dataWS = XLSX.utils.json_to_sheet(json, { origin: 'A8' })
      else dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
    },
    sapFormat(data) {
      var companyCode = '100'
      var systemCode = '10'
      var batchNo = dayjs().format('YYYYMMDD') + '001'
      var lotNo = companyCode + systemCode + batchNo

      var orders = []

      var prefix_filename = ''

      switch (this.selectedBot.pageid) {
        case '488563718210335': // moniga
          prefix_filename = 'MG_'
          break
        case '135565533158593': // monobo
          prefix_filename = 'MB_'
          break
        case '1229692217050821': // Kardas
          prefix_filename = 'KD_'
          break
        case '148831989096546': // Rubber Soul
          prefix_filename = 'RBS_'
          break

        default:
          break
      }

      // U_CompanyCode	U_SystemCode	U_TransBatchNo	U_LotNo	DocNum	NumAtCard	U_Status	DocDate	DocDueDate	DocTime	Comments	U_Channel	CardCode	CardName	U_SocialName	Address	U_Shipping	U_TrackingNo	DocCur	DocRate	DiscPrcnt	DocTotal	PaidSum	U_TrnsfDate

      // invoice header
      var invoiceHeader = data.map(el => {
        var realname = el.nameaddress.split(' , ')
        var shippingType = ''
        try {
          var jsondata = JSON.parse(el.shippingtype)
          if (jsondata.type) {
            shippingType = jsondata.type
          }
        } catch (error) {
          shippingType = el.shippingtype
        }
        var tel =
          realname.length > 1
            ? realname[realname.length - 1].replace(/-/g, '').replace(/ /g, '')
            : ''
        try {
          tel = tel.replace('+66', '0').match(/[0-9]+/g)[0]
        } catch (error) {
          tel = ''
        }
        var remark = ''
        try {
          remark = el.remark ? el.remark.replace(/[|]/g, '').replace(/\n/g, '') : ''
          remark = remark && remark.split(';;').length > 0 ? remark.split(';;')[0] : ''
        } catch (error) {
          remark = el.remark ? el.remark.replace(/\n/g, '').replace(/|/g, '') : ''
        }

        return [
          companyCode,
          systemCode,
          batchNo,
          lotNo,
          el.id,
          el.id,
          el.status,
          dayjs(el.timestamp).format('YYYYMMDD'),
          dayjs(el.timestamp).format('YYYYMMDD'),
          dayjs(el.timestamp).format('HHmm'),
          remark,
          el.app,
          tel,
          realname.length > 1 ? realname[0] : '',
          el.first_name + ' ' + el.last_name,
          el.nameaddress.replace(/\n/g, ' ').replace(/[|]/g, ''),
          shippingType ? this.$t(shippingType) : '',
          el.trackingno,
          'THB',
          1,
          el.discount,
          numeral(el.amount)
            .format('0.00')
            .toString(),
          numeral(el.amount)
            .format('0.00')
            .toString(),
          ''
        ].join('|')
      })

      var invoiceDetails = data.map(el => {
        var realname = el.nameaddress.split(' , ')
        var shippingType = ''

        var productdetail = []
        try {
          var products = JSON.parse(el.productdetail)
        } catch (error) {
          var products = el.productdetail
        }
        try {
          if (typeof products == 'object' && products.length > 0) {
            productdetail = products.map(function(product) {
              return {
                name: product.name ? product.name : '',
                quantity: product.quantity,
                sku: product.sku ? product.sku : '',
                option: product.option ? ' (' + product.option + ')' : '',
                price: product.price > 0 ? product.price : 'Free'
              }
            })
          } else {
            productdetail[0] = el.productdetail
          }
        } catch (error) {
          productdetail[0] = el.productdetail
        }

        try {
          var jsondata = JSON.parse(el.shippingtype)
          if (jsondata.type) {
            shippingType = jsondata.type
          }
        } catch (error) {
          shippingType = el.shippingtype
        }

        var result = productdetail.map((detail, dindex) => {
          return [
            companyCode,
            systemCode,
            batchNo,
            lotNo,
            el.id,
            dindex,
            detail.sku,
            detail.name + detail.option,
            detail.quantity,
            numeral(detail.price / detail.quantity)
              .format('0.00')
              .toString(),
            numeral(detail.price)
              .format('0.00')
              .toString(),
            '',
            '',
            '',
            '',
            '',
            ''
          ].join('|')
        })

        return result.join('\n')
      })

      var paymentHeader = data.map(el => {
        var realname = el.nameaddress.split(' , ')
        var shippingType = ''
        try {
          var jsondata = JSON.parse(el.shippingtype)
          if (jsondata.type) {
            shippingType = jsondata.type
          }
        } catch (error) {
          shippingType = el.shippingtype
        }

        var bankname = ''
        try {
          bankname = el.remark && el.remark.split(';;').length > 1 ? el.remark.split(';;')[1] : ''
        } catch (error) {
          bankname = ''
        }
        var tel =
          realname.length > 1
            ? realname[realname.length - 1].replace(/-/g, '').replace(/ /g, '')
            : ''
        try {
          tel = tel.replace('+66', '0').match(/[0-9]+/g)[0]
        } catch (error) {
          tel = ''
        }
        return [
          companyCode,
          systemCode,
          batchNo,
          lotNo,
          el.id,
          dayjs(el.timestamp).format('YYYYMMDD'),
          dayjs(el.timestamp).format('HHmm'),
          tel,
          realname.length > 1 ? realname[0] : '',
          'THB',
          1,
          '',
          numeral(el.amount)
            .format('0.00')
            .toString(),
          '',
          '',
          '',
          '',
          bankname,
          '',
          '',
          ''
        ].join('|')
      })

      var paymentDetails = data.map(el => {
        var realname = el.nameaddress.split(' , ')
        var shippingType = ''

        var productdetail = []
        try {
          var products = JSON.parse(el.productdetail)
        } catch (error) {
          var products = el.productdetail
        }
        try {
          if (typeof products == 'object' && products.length > 0) {
            productdetail = products.map(function(product) {
              return {
                name: product.name ? product.name : '',
                quantity: product.quantity,
                sku: product.sku ? product.sku : '',
                option: product.option ? ' (' + product.option + ')' : '',
                price: product.price > 0 ? product.price : 'Free'
              }
            })
          } else {
            productdetail[0] = el.productdetail
          }
        } catch (error) {
          productdetail[0] = el.productdetail
        }

        try {
          var jsondata = JSON.parse(el.shippingtype)
          if (jsondata.type) {
            shippingType = jsondata.type
          }
        } catch (error) {
          shippingType = el.shippingtype
        }

        var result = productdetail.map((detail, dindex) => {
          return [
            companyCode,
            systemCode,
            batchNo,
            lotNo,
            el.id,
            dindex,
            el.id,
            numeral(detail.price)
              .format('0.00')
              .toString()
          ].join('|')
        })

        return result.join('\n')
      })
      var invoiceHeader_Header = [
        'U_CompanyCode',
        'U_SystemCode',
        'U_TransBatchNo',
        'U_LotNo',
        'DocNum',
        'NumAtCard',
        'U_Status',
        'DocDate',
        'DocDueDate',
        'DocTime',
        'Comments',
        'U_Channel',
        'CardCode',
        'CardName',
        'U_SocialName',
        'Address',
        'U_Shipping',
        'U_TrackingNo',
        'DocCur',
        'DocRate',
        'DiscPrcnt',
        'DocTotal',
        'PaidSum',
        'U_TrnsfDate'
      ]
      invoiceHeader_Header = invoiceHeader_Header.join('|')
      invoiceHeader.unshift(invoiceHeader_Header)
      this.exportText(
        invoiceHeader.join('\n'),
        `${prefix_filename}${companyCode}_${systemCode}_${batchNo}_${lotNo}_OINV_H`
      )

      var invoiceDetails_header = [
        'U_CompanyCode',
        'U_SystemCode',
        'U_TransBatchNo',
        'U_LotNo',
        'DocNum',
        'LineNum',
        'ItemCode',
        'Dscription',
        'Quantity',
        'PriceAfVAT',
        'LineTotal',
        'WhsCode',
        'UseBaseUn',
        'OcrCode',
        'OcrCode3',
        'OcrCode4',
        'OcrCode5'
      ]
      invoiceDetails_header = invoiceDetails_header.join('|')
      invoiceDetails.unshift(invoiceDetails_header)
      this.exportText(
        invoiceDetails.join('\n'),
        `${prefix_filename}${companyCode}_${systemCode}_${batchNo}_${lotNo}_INV1_L`
      )

      var paymentHeader_header = [
        'U_CompanyCode',
        'U_SystemCode',
        'U_TransBatchNo',
        'U_LotNo',
        'DocNum',
        'DocDate',
        'DocTime',
        'CardCode',
        'CardName',
        'DocCurrency',
        'DocRate',
        'CashSum',
        'TransferSum',
        'CreditSum',
        'CheckSum',
        'CashAccount',
        'CheckAccount',
        'TransferAccount',
        'BankCode',
        'BankAccount',
        'Remarks'
      ]
      paymentHeader_header = paymentHeader_header.join('|')
      paymentHeader.unshift(paymentHeader_header)
      this.exportText(
        paymentHeader.join('\n'),
        `${prefix_filename}${companyCode}_${systemCode}_${batchNo}_${lotNo}_ORCT_H`
      )

      var paymentDetails_header = [
        'U_CompanyCode',
        'U_SystemCode',
        'U_TransBatchNo',
        'U_LotNo',
        'ParentKey',
        'LineNum',
        'DocEntry',
        'PaidSum'
      ]
      paymentDetails_header = paymentDetails_header.join('|')
      paymentDetails.unshift(paymentDetails_header)
      this.exportText(
        paymentDetails.join('\n'),
        `${prefix_filename}${companyCode}_${systemCode}_${batchNo}_${lotNo}_RCT2_L`
      )
    },
    handleChangeBillType(billType) {
      if (billType === 'conversion') {
        this.hasSalePage = this.social.includes('salepage')
        this.$nextTick(() => {
          this.social = this.social.filter(social => social !== 'salepage')
        })
      } else if (this.hasSalePage && this.socialOptions.find(opt => opt.value === 'salepage')) {
        this.social.push('salepage')
        this.hasSalePage = false
      }
    },
    activeFilterCreatedBy(type) {
      if (!this.filterCreatedBy.includes(type)) {
        this.filterCreatedBy.push(type)
      }
      if (this.pageNumber > this.pageCount) {
        this.pageNumber = this.pageCount
      }
    },
    inactiveFilterCreatedBy(type) {
      this.filterCreatedBy = this.filterCreatedBy.filter(item => item !== type)
      if (this.pageNumber > this.pageCount) {
        this.pageNumber = this.pageCount
      }
    },
    // activeFilterStatus(status) {
    //   if (!this.filterStatus.includes(status)) {
    //     this.filterStatus.push(status)
    //   }
    //   if (this.pageNumber > this.pageCount) {
    //     this.pageNumber = this.pageCount
    //   }
    // },
    // inactiveFilterStatus(status) {
    //   this.filterStatus = this.filterStatus.filter(item => item !== status)
    //   if (this.pageNumber > this.pageCount) {
    //     this.pageNumber = this.pageCount
    //   }
    // },
    removeOrderNumber(item) {
      this.orderNumbers = this.orderNumbers.filter(order => order !== item)
    }
  },
  watch: {
    search: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.pageNumber = 1
        this.clearSelectAll()
      }
    }
  }
}
</script>

<style scoped>
.custom-menu {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ecommerce-order-summary.vue